export const GLOSSARY = [
  {
    "key": 1,
    "value": "5G",
    "description": "The fifth generation of cellular network technology that includes significantly faster data transfer rates than older generations."
  },
  {
    "key": 2,
    "value": "acceptable use policy (AUP)",
    "description": "Organizational policy that describes both acceptable and unacceptable actions when using organizational computing resources, as well as the consequences of violating the policy."
  },
  {
    "key": 3,
    "value": "access control",
    "description": "Any means that detects or prevents unauthorized access and that permits authorized access."
  },
  {
    "key": 4,
    "value": "access control list (ACL)",
    "description": "An access control method whereby a list of permitted or denied users (or systems or services, as the case might be) is used to control access."
  },
  {
    "key": 5,
    "value": "access control log",
    "description": "A record of attempted accesses."
  },
  {
    "key": 6,
    "value": "access control policy",
    "description": "A statement that defines the policy for the granting, review, and revocation of access to systems and work areas."
  },
  {
    "key": 7,
    "value": "access creep",
    "description": "See accumulation of privileges."
  },
  {
    "key": 8,
    "value": "access management",
    "description": "A formal business process for controlling access to networks and information systems."
  },
  {
    "key": 9,
    "value": "access point",
    "description": "A device that provides communication services using the 802.11 (Wi-Fi) protocol standard."
  },
  {
    "key": 10,
    "value": "access review",
    "description": "A review of the users, systems, or other subjects that are permitted to access protected objects to ensure that all subjects are authorized to have access."
  },
  {
    "key": 11,
    "value": "accumulation of privileges",
    "description": "The gradual accumulation of access rights by an individual over long periods of time."
  },
  {
    "key": 12,
    "value": "Active Directory",
    "description": "See Microsoft Active Directory (AD)."
  },
  {
    "key": 13,
    "value": "administrative audit",
    "description": "An audit of operational efficiency."
  },
  {
    "key": 14,
    "value": "advanced persistent threat (APT)",
    "description": "A threat actor that works slowly but effectively to compromise a target organization, often employing techniques to avoid detection."
  },
  {
    "key": 15,
    "value": "advertising cookie",
    "description": "See persistent cookie."
  },
  {
    "key": 16,
    "value": "aggregation",
    "description": "See data aggregation."
  },
  {
    "key": 17,
    "value": "agile",
    "description": "A software development process in which a large project team is divided into smaller teams and project deliverables are divided into smaller pieces, each of which can be attained in a few weeks."
  },
  {
    "key": 18,
    "value": "AirTag",
    "description": "See Apple AirTag."
  },
  {
    "key": 19,
    "value": "algorithm",
    "description": "In cryptography, a specific mathematical formula used to perform encryption, decryption, message digests, and digital signatures."
  },
  {
    "key": 20,
    "value": "annualized loss expectancy (ALE)",
    "description": "In quantitative risk analysis, the expected loss of asset value resulting from threat realization. ALE is defined as single loss expectancy (SLE) × annualized rate of occurrence (ARO). See also annualized rate of occurrence (ARO), asset value (AV), exposure factor (EF), annualized loss expectancy (ALE), annualized rate of occurrence (ARO)."
  },
  {
    "key": 21,
    "value": "annualized rate of occurrence (ARO)",
    "description": "In quantitative risk analysis, an estimate of the number of times that a threat will occur every year. See also annualized rate of occurrence (ARO), asset value (AV), exposure factor (EF), annualized loss expectancy (ALE), annualized loss expectancy (ALE)."
  },
  {
    "key": 22,
    "value": "anonymization",
    "description": "An irreversible de-identification procedure in which specific identifiers that relate personal information to a specific individual are removed. See also de-identification, k-anonymization, masking, pseudonymization, re-identification, tokenization."
  },
  {
    "key": 23,
    "value": "antimalware",
    "description": "Software that uses various means to detect and block malware. See also antivirus software."
  },
  {
    "key": 24,
    "value": "antivirus software",
    "description": "Software designed to detect and remove viruses and other forms of malware. See also antimalware."
  },
  {
    "key": 25,
    "value": "Apple AirTag",
    "description": "A compact tracking device used to locate objects such as keys, wallets, luggage, or vehicles."
  },
  {
    "key": 26,
    "value": "Apple File System (APFS)",
    "description": "A file system used by the Apple macOS operating system. See also file system."
  },
  {
    "key": 27,
    "value": "appliance",
    "description": "A type of computer with preinstalled software that requires little or no maintenance."
  },
  {
    "key": 28,
    "value": "application allowlisting",
    "description": "A tool that permits only approved programs to execute on a computer."
  },
  {
    "key": 29,
    "value": "application programming interface (API)",
    "description": "A machine-connected computer interface through which programs can communicate with one another."
  },
  {
    "key": 30,
    "value": "application programming language",
    "description": "See programming language."
  },
  {
    "key": 31,
    "value": "application server",
    "description": "A server that runs one or more business application software programs."
  },
  {
    "key": 32,
    "value": "application whitelisting",
    "description": "See application allowlisting."
  },
  {
    "key": 33,
    "value": "architecture standard",
    "description": "A standard that defines technology architecture at the database, system, or network level."
  },
  {
    "key": 34,
    "value": "ARCI",
    "description": "See RACI."
  },
  {
    "key": 35,
    "value": "artifacts",
    "description": "Information that represents ongoing activities, as well as the directives driving those activities. See also evidence."
  },
  {
    "key": 36,
    "value": "artificial intelligence (AI)",
    "description": "The study and practice of using software or hardware agents that mimic human cognition and are designed for tasks such as learning and problem-solving."
  },
  {
    "key": 37,
    "value": "asset",
    "description": "The collection of property that is owned by an organization, including digitally stored information."
  },
  {
    "key": 38,
    "value": "asset inventory",
    "description": "The process of confirming the existence, location, and condition of assets; also, the results of such a process."
  },
  {
    "key": 39,
    "value": "asset management",
    "description": "The processes used to manage the inventory, classification, use, and disposal of assets."
  },
  {
    "key": 40,
    "value": "asset value (AV)",
    "description": "In quantitative risk analysis, the value of an IT asset, which is usually (but not necessarily) the asset’s replacement value."
  },
  {
    "key": 41,
    "value": "asymmetric encryption",
    "description": "A method for encryption, decryption, and digital signatures that uses pairs of encryption keys consisting of a public key and a private key. Also known as public-key cryptography."
  },
  {
    "key": 42,
    "value": "attack surface",
    "description": "The people, processes, and technologies present in a system or environment that can be exploited by an attacker."
  },
  {
    "key": 43,
    "value": "attack surface reduction",
    "description": "The intentional reduction in the number of entry points, interfaces, and exposures that attackers could exploit."
  },
  {
    "key": 44,
    "value": "attorney-client privilege",
    "description": "A common legal practice that states that communications between employees and an organization’s general counsel are exempt from legal discovery."
  },
  {
    "key": 45,
    "value": "attribute sampling",
    "description": "A sampling technique used to study the characteristics of a population to determine how many samples possess a specific characteristic. See also sampling."
  },
  {
    "key": 46,
    "value": "audit log",
    "description": "A feature in an application, operating system, or database management system that enables security-related events to be recorded in a separate log. See also event log."
  },
  {
    "key": 47,
    "value": "audit objective",
    "description": "The purpose or goals of an audit. Generally, the objective of an audit is to determine whether controls exist and are effective in a specific aspect of an organization’s business operations."
  },
  {
    "key": 48,
    "value": "audit procedures",
    "description": "The step-by-step instructions and checklists required to perform specific audit activities. Procedures can include a list of people to interview and questions to ask them, evidence to request, audit tools to use, sampling rates, where and how evidence will be archived, and how evidence will be evaluated."
  },
  {
    "key": 49,
    "value": "audit report",
    "description": "The final, written product of an audit. An audit report will include a description of the purpose, scope, and type of audit performed; the persons interviewed; the evidence collected; the rates and methods of sampling; and the findings on the existence and effectiveness of each control."
  },
  {
    "key": 50,
    "value": "authentication",
    "description": "The process of asserting one’s identity and providing proof of that identity. Typically, authentication requires a user ID (the assertion) and a password (the proof). However, authentication can also require stronger forms of proof, such as a digital certificate, token, smart card, or biometric identifier."
  },
  {
    "key": 51,
    "value": "authorization",
    "description": "The process by which a system determines a user’s rights and privileges."
  },
  {
    "key": 52,
    "value": "automated decision-making technology (ADMT)",
    "description": "Technology that uses algorithms, data processing, or artificial intelligence to make or assist in decisions about individuals without meaningful human involvement."
  },
  {
    "key": 53,
    "value": "backdoor",
    "description": "A section of code that permits someone to bypass access controls and access data or functions. Backdoors are commonly added to programs during development but removed before programming is complete. Attackers also create backdoors to aid their continued presence."
  },
  {
    "key": 54,
    "value": "background check",
    "description": "The process of verifying an employment candidate’s employment history, education records, professional licenses and certifications, criminal background, and financial background."
  },
  {
    "key": 55,
    "value": "background verification",
    "description": "See background check."
  },
  {
    "key": 56,
    "value": "backup",
    "description": "The process of copying important data to another media device in the event of a hardware failure, error, or software bug that causes damage to data."
  },
  {
    "key": 57,
    "value": "backward lineage",
    "description": "The tracking records for a dataset, tracing it back to its origin, including its sources, transformations, and ownership. Otherwise known as data provenance."
  },
  {
    "key": 58,
    "value": "bacon",
    "description": "Salt-cured pork."
  },
  {
    "key": 59,
    "value": "beacon",
    "description": "See web beacon."
  },
  {
    "key": 60,
    "value": "big data",
    "description": "The field of study into large databases for improved analysis and discovery."
  },
  {
    "key": 61,
    "value": "binding corporate rules (BCR)",
    "description": "Internal data protection policies established by multi-national organizations that transmit personal information between legal jurisdictions as a form of self-regulation. See also standard contractual clauses (SCCs)."
  },
  {
    "key": 62,
    "value": "biometrics",
    "description": "Any use of a machine-readable characteristic of a user’s body that uniquely identifies the user. Biometrics can be used for strong authentication. Types of biometrics include voice recognition, fingerprint recognition, hand scan, palm vein scan, iris scan, retina scan, facial scan, and handwriting recognition. See also authentication, strong authentication."
  },
  {
    "key": 63,
    "value": "block cipher",
    "description": "An encryption algorithm that operates on blocks of data. See also stream cipher."
  },
  {
    "key": 64,
    "value": "blockchain",
    "description": "A distributed ledger used to record cryptographically linked transactions."
  },
  {
    "key": 65,
    "value": "Bluetooth",
    "description": "A short-range air-link standard for data communications between peripherals and low-power consumption devices."
  },
  {
    "key": 66,
    "value": "bring-your-own-app (BYOA)",
    "description": "The phenomenon whereby workers use personally owned software to conduct organizational business."
  },
  {
    "key": 67,
    "value": "bring-your-own-device (BYOD)",
    "description": "The phenomenon in which workers use personally owned devices to connect to organizational networks and conduct organizational business."
  },
  {
    "key": 68,
    "value": "budget",
    "description": "A plan for allocating resources over a certain time period."
  },
  {
    "key": 69,
    "value": "buffer overflow",
    "description": "An attack on a computer program in which input data overruns input buffers, causing arbitrary code to overwrite the program’s code, thereby altering the execution of the program."
  },
  {
    "key": 70,
    "value": "bug bounty",
    "description": "A business arrangement in which an organization solicits independent researchers to perform security tests on a target system and then pays them for identifying previously unknown vulnerabilities."
  },
  {
    "key": 71,
    "value": "bus",
    "description": "A component in a computer that provides the means for the different components of the computer to communicate with one another."
  },
  {
    "key": 72,
    "value": "business associate agreement (BAA)",
    "description": "A legal agreement between two parties that sets forth general and specific measures to protect personal information, usually protected health information (PHI)."
  },
  {
    "key": 73,
    "value": "business case",
    "description": "An explanation of the expected benefits to the business that will be realized as a result of a program or project."
  },
  {
    "key": 74,
    "value": "business change management",
    "description": "A formal process through which changes are made to business processes."
  },
  {
    "key": 75,
    "value": "business functional requirements",
    "description": "See functional requirements."
  },
  {
    "key": 76,
    "value": "business impact analysis (BIA)",
    "description": "A study aimed at identifying the impacts of different disaster scenarios on ongoing business operations."
  },
  {
    "key": 77,
    "value": "business plan",
    "description": "A formal statement that describes the new business activity, its contribution and impact to the organization, any resources required to operate the activity, the benefits from operating the activity, and any risks associated with the activity."
  },
  {
    "key": 78,
    "value": "California Consumer Privacy Act (CCPA)",
    "description": "Privacy regulation enacted in 2018 (enforced in 2020) in California."
  },
  {
    "key": 79,
    "value": "California Consumer Privacy Rights Act (CPRA)",
    "description": "Privacy regulation enacted through a ballot initiative in 2020 in the U.S. State of California."
  },
  {
    "key": 80,
    "value": "Capability Maturity Model",
    "description": "A model used to measure the relative maturity of an organization or its processes."
  },
  {
    "key": 81,
    "value": "Capability Maturity Model Integration (CMMI)",
    "description": "A maturity model that represents the aggregation of other maturity models."
  },
  {
    "key": 82,
    "value": "CDMA (code-division multiple access)",
    "description": "An air-link standard for wireless communications between mobile devices and base stations."
  },
  {
    "key": 83,
    "value": "Center for Internet Security Critical Security Controls (CIS CSC)",
    "description": "A security controls framework developed by the Center for Internet Security (CIS)."
  },
  {
    "key": 84,
    "value": "central processing unit (CPU)",
    "description": "The main hardware component of a computer that executes program instructions."
  },
  {
    "key": 85,
    "value": "certificate authority (CA)",
    "description": "A trusted party that stores digital certificates and public encryption keys."
  },
  {
    "key": 86,
    "value": "certificate of destruction",
    "description": "An artifact that serves as evidence of data destruction, with details describing the data or media that was destroyed, and the method of destruction."
  },
  {
    "key": 87,
    "value": "certificate revocation list (CRL)",
    "description": "An electronic list of digital certificates that have been revoked before their expiration date."
  },
  {
    "key": 88,
    "value": "chain of custody",
    "description": "Documentation that shows the acquisition, storage, control, and analysis of evidence. The chain of custody might be needed if the evidence is to be used in a legal proceeding."
  },
  {
    "key": 89,
    "value": "change control",
    "description": "See change management."
  },
  {
    "key": 90,
    "value": "change management",
    "description": "The IT function used to control changes to an IT environment. See also IT service management."
  },
  {
    "key": 91,
    "value": "charter",
    "description": "See program charter."
  },
  {
    "key": 92,
    "value": "China Cybersecurity Law",
    "description": "A 2017 security and privacy law in China requiring organizations to protect personal information they hold."
  },
  {
    "key": 93,
    "value": "ciphertext",
    "description": "A message, file, or stream of data that has been transformed by an encryption algorithm and rendered unreadable. See also plaintext."
  },
  {
    "key": 94,
    "value": "citizen IT",
    "description": "See shadow IT."
  },
  {
    "key": 95,
    "value": "clientless VPN",
    "description": "A virtual private network (VPN) connection that can be established without the need for a VPN client program. See also remote access, VPN client."
  },
  {
    "key": 96,
    "value": "cloud",
    "description": "A generalization referring to the use of remote computers, storage, software, or networks, typically through a commercial service."
  },
  {
    "key": 97,
    "value": "cloud access security broker (CASB)",
    "description": "A system that monitors and, optionally, controls users’ access to cloud-based resources."
  },
  {
    "key": 98,
    "value": "cloud computing",
    "description": "A technique of providing a dynamically scalable and usually virtualized computing resource as a service."
  },
  {
    "key": 99,
    "value": "cloud responsibility model",
    "description": "See shared responsibility model."
  },
  {
    "key": 100,
    "value": "cloud service provider (CSP)",
    "description": "A service provider that offers infrastructure-as-a-service (IaaS), platform-as-a-service (PaaS), software-as-a-service (SaaS), or other offerings."
  },
  {
    "key": 101,
    "value": "cluster",
    "description": "A set of connected computers used to solve a common task. In a cluster, one or more servers actively perform tasks, while zero or more computers can be in a “standby” state, ready to assume active duty should the need arise."
  },
  {
    "key": 102,
    "value": "code of conduct",
    "description": "See code of ethics."
  },
  {
    "key": 103,
    "value": "code of ethics",
    "description": "A statement that defines acceptable and unacceptable professional conduct within an organization."
  },
  {
    "key": 104,
    "value": "code review",
    "description": "A manual review of the application source code to confirm that code changes have not introduced new vulnerabilities."
  },
  {
    "key": 105,
    "value": "collection",
    "description": "See data collection."
  },
  {
    "key": 106,
    "value": "colocation",
    "description": "The use of a commercial data center where customers lease space in equipment cabinets or cages."
  },
  {
    "key": 107,
    "value": "Common Vulnerability Scoring System (CVSS)",
    "description": "A standard methodology for rating system vulnerabilities based on the ease and impact of exploitation."
  },
  {
    "key": 108,
    "value": "compensating control",
    "description": "A control that is implemented because another control cannot be implemented or is ineffective."
  },
  {
    "key": 109,
    "value": "compliance audit",
    "description": "An audit to determine the level and degree of compliance with a law, regulation, standard, contract provision, or internal control."
  },
  {
    "key": 110,
    "value": "compliance risk",
    "description": "Risk that is associated with failure to comply with laws, regulations, and other legal obligations."
  },
  {
    "key": 111,
    "value": "confidential computing",
    "description": "See trusted execution environment."
  },
  {
    "key": 112,
    "value": "configuration management",
    "description": "The process of recording and maintaining the configuration of IT systems."
  },
  {
    "key": 113,
    "value": "configuration standard",
    "description": "A standard that defines the detailed configurations that are used in servers, workstations, operating systems, database management systems, applications, network devices, and other systems."
  },
  {
    "key": 114,
    "value": "connected devices",
    "description": "Devices connected to wired or wireless networks with little or no human-interaction features. See also industrial control system (ICS), Internet of Things (IoT), Supervisory Control and Data Acquisition (SCADA)."
  },
  {
    "key": 115,
    "value": "consent",
    "description": "Freely given permission granted by a data subject for the collection and/or processing of their personal data."
  },
  {
    "key": 116,
    "value": "consent attributes",
    "description": "See consent tagging."
  },
  {
    "key": 117,
    "value": "consent labels",
    "description": "See consent tagging."
  },
  {
    "key": 118,
    "value": "consent metadata",
    "description": "See consent tagging."
  },
  {
    "key": 119,
    "value": "consent tagging",
    "description": "The assignment of metadata to personal data or processing activities that record the scope, purpose, and status of a data subject’s consent, so that permitted uses and restrictions can be automatically enforced."
  },
  {
    "key": 120,
    "value": "contact tracing",
    "description": "The process of identifying persons who have been in proximity to a person carrying an infectious disease."
  },
  {
    "key": 121,
    "value": "containerization",
    "description": "A method of virtualization in which several isolated operating zones are created in a running server operation, so that programs and data can be isolated within their respective containers."
  },
  {
    "key": 122,
    "value": "continuous improvement",
    "description": "The management philosophy that states there is always room to improve a process or system."
  },
  {
    "key": 123,
    "value": "continuous integration/continuous deployment (CI/CD)",
    "description": "A software development and deployment methodology in which developers’ source code changes are merged into a mainline codebase multiple times each day, and multiple incremental software updates are deployed through automated deployment multiple times each day."
  },
  {
    "key": 124,
    "value": "continuous log review",
    "description": "The use of automation to review event logs in real time. See also security information and event management (SIEM) system."
  },
  {
    "key": 125,
    "value": "contract",
    "description": "A binding legal agreement between two parties that is enforceable in a court of law."
  },
  {
    "key": 126,
    "value": "control",
    "description": "A policy, process, or procedure that is created to achieve a desired event or to avoid an unwanted event."
  },
  {
    "key": 127,
    "value": "control framework",
    "description": "A collection of controls that are organized into logical categories."
  },
  {
    "key": 128,
    "value": "control objective",
    "description": "A foundational statement that describes desired states or outcomes from business operations."
  },
  {
    "key": 129,
    "value": "control self-assessment (CSA)",
    "description": "A methodology used by an organization to review key business objectives, risks, and controls. Control self-assessment is generally a self-regulation activity."
  },
  {
    "key": 130,
    "value": "cookie",
    "description": "A block of data stored by a browser on a user’s computer, as directed by a website."
  },
  {
    "key": 131,
    "value": "corporate values statement",
    "description": "An organization’s official statement of culture and values."
  },
  {
    "key": 132,
    "value": "countermeasure",
    "description": "Any activity or mechanism that is designed to reduce risk."
  },
  {
    "key": 133,
    "value": "covered entity",
    "description": "An organization that is obligated to comply with the Health Insurance Portability and Accountability Act (HIPAA)."
  },
  {
    "key": 134,
    "value": "cross-border data transfer",
    "description": "The transfer of data, typically personal information, across a state, provincial, or national border."
  },
  {
    "key": 135,
    "value": "crosswalk",
    "description": "A table or chart that depicts controls from different control frameworks matched together."
  },
  {
    "key": 136,
    "value": "cryptanalysis",
    "description": "An attack on a cryptosystem in which the attacker attempts to determine the encryption key used to encrypt messages."
  },
  {
    "key": 137,
    "value": "cryptography",
    "description": "The practice of hiding information from unwanted persons."
  },
  {
    "key": 138,
    "value": "cryptoperiod",
    "description": "The length of time that an encryption key is considered valid."
  },
  {
    "key": 139,
    "value": "cryptosystem",
    "description": "A set of algorithms used to generate an encryption key, perform encryption, and perform decryption."
  },
  {
    "key": 140,
    "value": "culture",
    "description": "The behavioral norms in an organization."
  },
  {
    "key": 141,
    "value": "custodian",
    "description": "A person or group delegated to operate or maintain an asset."
  },
  {
    "key": 142,
    "value": "cutover",
    "description": "The planned transition point and execution process in which operations switch from a legacy system to a new system during a migration. See also migration."
  },
  {
    "key": 143,
    "value": "Cybersecurity Framework (CSF)",
    "description": "See NIST CSF."
  },
  {
    "key": 144,
    "value": "data aggregation",
    "description": "The process of combining datasets to enrich available data."
  },
  {
    "key": 145,
    "value": "data archival",
    "description": "The process of preparing or transforming data for long-term storage."
  },
  {
    "key": 146,
    "value": "data classification",
    "description": "The process of assigning a sensitivity classification to a dataset or information asset."
  },
  {
    "key": 147,
    "value": "data classification policy",
    "description": "A policy that defines sensitivity levels and handling procedures for information."
  },
  {
    "key": 148,
    "value": "data collection",
    "description": "In the context of data privacy, the acquisition of personal information about one or more data subjects."
  },
  {
    "key": 149,
    "value": "data control language (DCL)",
    "description": "The mechanism that is used to configure and enforce access control in a relational database. See also relational database management system (RDBMS)."
  },
  {
    "key": 150,
    "value": "data controller",
    "description": "An entity that determines the purposes and means of the processing of personal data, which can include directing third parties to process personal data on the entity’s behalf."
  },
  {
    "key": 151,
    "value": "data destruction",
    "description": "The purposeful act of destroying data so that it cannot be recovered."
  },
  {
    "key": 152,
    "value": "data destruction policy",
    "description": "Policy that states business rules for data destruction, including techniques to be used."
  },
  {
    "key": 153,
    "value": "data disclosure",
    "description": "An instance where data is moved from one entity to another. See also data migration, data transfer."
  },
  {
    "key": 154,
    "value": "data discovery",
    "description": "A process, usually automated, whereby data stores are scanned to determine the presence of specific information, typically personal and other sensitive information."
  },
  {
    "key": 155,
    "value": "data definition language (DDL)",
    "description": "A procedural language used to describe the structure of data contained in a database."
  },
  {
    "key": 156,
    "value": "data dictionary (DD)",
    "description": "A set of data in a database management system that describes the structure of databases stored there."
  },
  {
    "key": 157,
    "value": "data filtering",
    "description": "See input validation."
  },
  {
    "key": 158,
    "value": "data flow diagram (DFD)",
    "description": "A diagram that illustrates the flow of data within and between systems."
  },
  {
    "key": 159,
    "value": "data governance",
    "description": "Policies and processes that result in management’s visibility and control over all data management and data processing activities in an organization."
  },
  {
    "key": 160,
    "value": "data lake",
    "description": "An aggregation of an organization’s databases into a single store. See also data warehouse."
  },
  {
    "key": 161,
    "value": "data lineage",
    "description": "The lifecycle of data within a system, documenting data flows and transformations. See also data provenance."
  },
  {
    "key": 162,
    "value": "data loss prevention (DLP)",
    "description": "Any of several tools and methods used for gaining visibility and control over the presence and movement of sensitive data."
  },
  {
    "key": 163,
    "value": "data marking",
    "description": "Any means for applying machineor human-readable marks on a document to identify it as containing personal or other sensitive information. See also data tagging."
  },
  {
    "key": 164,
    "value": "data masking",
    "description": "See masking."
  },
  {
    "key": 165,
    "value": "data migration",
    "description": "A process of transferring data from one production system to another within an organization. See also data disclosure, data transfer."
  },
  {
    "key": 166,
    "value": "data minimization",
    "description": "See minimization."
  },
  {
    "key": 167,
    "value": "data processing agreement",
    "description": "A legal agreement that stipulates how a third party is to process and protect personal data, notify in case of breach, and other terms."
  },
  {
    "key": 168,
    "value": "data processor",
    "description": "An entity that processes data at the direction of a data controller. See also data controller."
  },
  {
    "key": 169,
    "value": "data protection impact assessment (DPIA)",
    "description": "An analysis of how planned changes to a business process or information system will impact an organization’s ability to protect specific types of data, such as personally identifiable information (PII). See also privacy impact assessment (PIA)."
  },
  {
    "key": 170,
    "value": "data protection officer (DPO)",
    "description": "A position tasked with ensuring that the organization’s privacy policies and practices are compliant with applicable laws, regulations, and other legal obligations."
  },
  {
    "key": 171,
    "value": "data provenance",
    "description": "A business record that documents the origin and original characteristics of a dataset. See also data lineage."
  },
  {
    "key": 172,
    "value": "data quality",
    "description": "The state of a dataset in terms of its accuracy and completeness."
  },
  {
    "key": 173,
    "value": "data retention",
    "description": "A portion of data governance. A formal approach for determining how long data should reside in an organization, and the process of developing procedures for removing data that has exceeded its retention limit."
  },
  {
    "key": 174,
    "value": "data retention schedule",
    "description": "A formal statement that specifies how long various types of business records should be retained in an organization."
  },
  {
    "key": 175,
    "value": "data science",
    "description": "Techniques used to gain insight about a dataset."
  },
  {
    "key": 176,
    "value": "data sovereignty",
    "description": "The concept of data that is subject to laws within the jurisdiction in which it is collected."
  },
  {
    "key": 177,
    "value": "data sprawl",
    "description": "The proliferation of data beyond its intended bounds."
  },
  {
    "key": 178,
    "value": "data subject",
    "description": "An identifiable natural person."
  },
  {
    "key": 179,
    "value": "data subject access request (DSAR)",
    "description": "See data subject request (DSR)."
  },
  {
    "key": 180,
    "value": "data subject request (DSR)",
    "description": "A request or inquiry sent to an organization by a data subject for verification, correction, or removal of personal information."
  },
  {
    "key": 181,
    "value": "data tagging",
    "description": "A typically automated process of applying an identifying mark on a data file if its contents meet specific criteria."
  },
  {
    "key": 182,
    "value": "data transfer",
    "description": "The act of transferring data from one organization to another. See also data disclosure, data migration."
  },
  {
    "key": 183,
    "value": "data warehouse",
    "description": "A set of data that has been copied from a production system and used for reporting, research, or archival purposes. See also data lake."
  },
  {
    "key": 184,
    "value": "database",
    "description": "A collection of structured or unstructured information."
  },
  {
    "key": 185,
    "value": "database management system (DBMS)",
    "description": "A software program that facilitates the storage and retrieval of potentially large amounts of structured or unstructured information."
  },
  {
    "key": 186,
    "value": "database server",
    "description": "A server that contains and facilitates access to one or more databases."
  },
  {
    "key": 187,
    "value": "DBMS",
    "description": "See database management system."
  },
  {
    "key": 188,
    "value": "decommissioning",
    "description": "See retirement."
  },
  {
    "key": 189,
    "value": "decryption",
    "description": "The process of transforming ciphertext into plaintext so that a recipient can read it."
  },
  {
    "key": 190,
    "value": "default password",
    "description": "A password associated with a user account or system account that retains its factory default setting."
  },
  {
    "key": 191,
    "value": "degaussing",
    "description": "The application of a strong magnetic field to erase the contents of magnetic storage media."
  },
  {
    "key": 192,
    "value": "de-identification",
    "description": "Any procedure through which specific identifiers about a data subject are removed or replaced. See also anonymization, k-anonymization, masking, pseudonymization, re-identification, tokenization."
  },
  {
    "key": 193,
    "value": "denial of service (DoS) attack",
    "description": "An attack on a computer or network with the intention of causing disruption or malfunction of the target."
  },
  {
    "key": 194,
    "value": "development stack",
    "description": "A software development environment, such as Eclipse— Subversion—Jenkins."
  },
  {
    "key": 195,
    "value": "DevOps",
    "description": "An agile software development and operations model that blurs the line between development and operations."
  },
  {
    "key": 196,
    "value": "DevSecOps",
    "description": "An agile and secure software development and operations model that relies on automated security testing in the development-deployment process."
  },
  {
    "key": 197,
    "value": "Diameter",
    "description": "An authentication, authorization, and accounting (AAA) protocol that evolved from RADIUS."
  },
  {
    "key": 198,
    "value": "differential privacy",
    "description": "A technique for releasing information about datasets by injecting noise into the dataset, thereby limiting the ability to infer information about any individual data subject."
  },
  {
    "key": 199,
    "value": "Diffie-Hellman",
    "description": "A popular key exchange algorithm. See also key exchange."
  },
  {
    "key": 200,
    "value": "digest",
    "description": "The result of a hash function applied to a block of data."
  },
  {
    "key": 201,
    "value": "digital certificate",
    "description": "An electronic document containing an identity signed with the private key of a certificate authority (CA)."
  },
  {
    "key": 202,
    "value": "digital envelope",
    "description": "A method that uses two layers of encryption: a symmetric key is used to encrypt a message, and then a public or private key is used to encrypt the symmetric key."
  },
  {
    "key": 203,
    "value": "digital fingerprinting",
    "description": "The collection of details of a data subject’s device, including device manufacturer and model, device name, the browser used, the operating system version, screen geometry, and other information."
  },
  {
    "key": 204,
    "value": "digital signature",
    "description": "The result of encrypting the hash of a message with the originator’s private encryption key, used to prove the message’s authenticity and integrity."
  },
  {
    "key": 205,
    "value": "digital subscriber line (DSL)",
    "description": "A common carrier standard for transporting data from the Internet to homes and businesses."
  },
  {
    "key": 206,
    "value": "directory",
    "description": "A structure in a file system that is used to store files and, optionally, other directories. See also file system."
  },
  {
    "key": 207,
    "value": "disaster recovery and business continuity requirements",
    "description": "Formal statements that describe required recoverability and continuity characteristics that a system must support."
  },
  {
    "key": 208,
    "value": "discovery sampling",
    "description": "An audit sampling technique in which an auditor tries to find at least one exception in the population. See also sampling."
  },
  {
    "key": 209,
    "value": "discretionary access control (DAC)",
    "description": "An access model used to control access to objects (files, directories, databases, systems, networks, and so on) by subjects (persons, programs, and so on). Access changes are performed by file and directory owners. See also mandatory access control (MAC)."
  },
  {
    "key": 210,
    "value": "disposition",
    "description": "See retirement."
  },
  {
    "key": 211,
    "value": "Do Not Track",
    "description": "A web browser feature that requests website operators refrain voluntarily from tracking individual visitors."
  },
  {
    "key": 212,
    "value": "document marking",
    "description": "The act of affixing a classification label to a document."
  },
  {
    "key": 213,
    "value": "documentation",
    "description": "The inclusive term that describes charters, processes, procedures, standards, requirements, and other written documents."
  },
  {
    "key": 214,
    "value": "dual control",
    "description": "See split custody."
  },
  {
    "key": 215,
    "value": "dynamic application security testing (DAST)",
    "description": "An automated scan of a running application to identify defects and security vulnerabilities."
  },
  {
    "key": 216,
    "value": "dynamic data loss prevention (dynamic DLP)",
    "description": "The use of tools to detect the movement of PII and other sensitive information. See also data loss prevention, static DLP."
  },
  {
    "key": 217,
    "value": "E-carrier",
    "description": "A class of multiplexed carrier network technologies developed to transport voice and data communications over long distances using copper cabling. See also T-carrier."
  },
  {
    "key": 218,
    "value": "eavesdropping",
    "description": "The practice of covertly observing a communications channel."
  },
  {
    "key": 219,
    "value": "elasticity",
    "description": "A feature of cloud environments that enables resources to be dynamically added or removed to service varying levels of work."
  },
  {
    "key": 220,
    "value": "electronic protected health information (ePHI)",
    "description": "Patient-related healthcare information in electronic form, as defined by the U.S. Health Insurance Portability and Accountability Act (HIPAA)."
  },
  {
    "key": 221,
    "value": "elliptic curve cryptography (ECC)",
    "description": "A public key cryptography algorithm."
  },
  {
    "key": 222,
    "value": "encapsulation",
    "description": "A technique in network protocols in which messages in higher-level protocols are contained within messages in lower-level protocols."
  },
  {
    "key": 223,
    "value": "encryption",
    "description": "The act of hiding sensitive information in plain sight. Encryption works by scrambling the characters in a message using a method known only to the sender and receiver, making it useless to anyone else who intercepts it."
  },
  {
    "key": 224,
    "value": "encryption key",
    "description": "A block of characters used in combination with an encryption algorithm to encrypt or decrypt a stream or block of data."
  },
  {
    "key": 225,
    "value": "end of life (EOL)",
    "description": "The state of a hardware or software product when the vendor no longer supports it."
  },
  {
    "key": 226,
    "value": "end user behavior analytics (EUBA)",
    "description": "See user behavior analytics (UBA)."
  },
  {
    "key": 227,
    "value": "endpoint",
    "description": "Any of several types of end-user devices, including desktop computers, laptop computers, tablet computers, and smartphones; also refers to non-end-user devices."
  },
  {
    "key": 228,
    "value": "endpoint detection and response (EDR)",
    "description": "Tools used to monitor, detect, investigate, and respond to malware and related threats on endpoints. See also antimalware, antivirus."
  },
  {
    "key": 229,
    "value": "engineering",
    "description": "The iterative application of scientific and mathematical principles to design, build, and operate systems that reliably meet defined objectives within real-world constraints."
  },
  {
    "key": 230,
    "value": "enterprise architecture",
    "description": "Activities that ensure IT systems meet important business needs; the model used to map business functions into the IT environment and IT systems at increasing levels of detail."
  },
  {
    "key": 231,
    "value": "entity-relationship diagram (ERD)",
    "description": "A diagram that depicts information in detail and that functions as a logical data model."
  },
  {
    "key": 232,
    "value": "entropy",
    "description": "In cryptography, the degree of randomness of an encryption key’s value."
  },
  {
    "key": 233,
    "value": "Ethernet",
    "description": "A standard protocol for assembling a stream of data into frames for transport over a physical medium from one station to another on a local area network. On an Ethernet network, any station is free to transmit a packet at any time, provided that another station is not already doing so."
  },
  {
    "key": 234,
    "value": "event log",
    "description": "A record of system activity to facilitate monitoring and troubleshooting."
  },
  {
    "key": 235,
    "value": "event monitoring",
    "description": "The practice of receiving and examining events occurring on information systems and devices."
  },
  {
    "key": 236,
    "value": "evidence",
    "description": "Information gathered by the auditor that provides proof that a process or control exists and is being operated. See also artifacts."
  },
  {
    "key": 237,
    "value": "exposure factor (EF)",
    "description": "In quantitative risk analysis, the financial loss that results from the realization of a threat, expressed as a percentage of the asset’s total value. See also annualized loss expectancy (ALE), annualized rate of occurrence (ARO), asset value (AV), single loss expectancy (SLE)."
  },
  {
    "key": 238,
    "value": "EXT4",
    "description": "A journaled file system is used by the Linux operating system. See also file system."
  },
  {
    "key": 239,
    "value": "extract, transform, load (ETL)",
    "description": "Software that transforms datasets, typically for migration from one system to another."
  },
  {
    "key": 240,
    "value": "extraterrestriality",
    "description": "A characteristic of an interplanetary regulation that exercises jurisdiction beyond the local Solar System."
  },
  {
    "key": 241,
    "value": "extraterritorial",
    "description": "A characteristic of a government regulation that exercises jurisdiction beyond its land borders."
  },
  {
    "key": 242,
    "value": "facial recognition",
    "description": "A capability, often coupled with video surveillance, to automatically recognize specific individuals based on their facial characteristics."
  },
  {
    "key": 243,
    "value": "facility classification",
    "description": "A method for assigning classification or risk levels to work centers and processing centers, based on their operational criticality and other risk factors."
  },
  {
    "key": 244,
    "value": "Factor Analysis of Information Risk (FAIR)",
    "description": "An analysis method that helps a risk analyst understand the factors that contribute to risk, the probability of threat occurrence, and potential losses."
  },
  {
    "key": 245,
    "value": "fail closed",
    "description": "A situation in which all access will be denied if the access control system fails."
  },
  {
    "key": 246,
    "value": "fail open",
    "description": "A situation in which all access will be permitted if an access control system fails."
  },
  {
    "key": 247,
    "value": "failover",
    "description": "The transition of processing duties from one system to another, usually because of a hardware or software fault."
  },
  {
    "key": 248,
    "value": "Fair Credit Reporting Act (FCRA)",
    "description": "A 1970 U.S. law that provides visibility, remedies, and assurances that information contained in consumers’ credit history is accurate."
  },
  {
    "key": 249,
    "value": "Fair Information Practice Principles (FIPP)",
    "description": "A set of internationally recognized guidelines that form the foundation of many modern privacy regulations."
  },
  {
    "key": 250,
    "value": "false negative",
    "description": "An activity that is mistakenly not identified as an event. See also false positive."
  },
  {
    "key": 251,
    "value": "false positive",
    "description": "An activity that is mistakenly identified as an event. See also false negative."
  },
  {
    "key": 252,
    "value": "Faraday bag",
    "description": "A bag constructed with electromagnetic shielding to protect its contents from electromagnetic radiation, such as Wi-Fi, Bluetooth, and cellular signals."
  },
  {
    "key": 253,
    "value": "feasibility study",
    "description": "An activity that seeks to determine the expected benefits of a program or project."
  },
  {
    "key": 254,
    "value": "fiber-optics",
    "description": "A cabling standard that uses optical fiber instead of metal conductors."
  },
  {
    "key": 255,
    "value": "fiduciary",
    "description": "A person who holds a legal trust relationship with a party, and who manages the party’s assets."
  },
  {
    "key": 256,
    "value": "fiduciary duty",
    "description": "The responsibilities carried out by a fiduciary."
  },
  {
    "key": 257,
    "value": "field",
    "description": "A unit of storage in a relational database management system that consists of a single data item within a row. See also relational database management system (RDBMS), row, table."
  },
  {
    "key": 258,
    "value": "field level access control",
    "description": "An API control that enforces access at the field level."
  },
  {
    "key": 259,
    "value": "file",
    "description": "A sequence of zero or more characters that is stored in a file system. A file can be a document, a spreadsheet, an image, a sound file, a computer program, or data that is used by a program. See also file system."
  },
  {
    "key": 260,
    "value": "file allocation table (FAT)",
    "description": "A file system used by the MS-DOS operating system as well as by early versions of the Microsoft Windows operating system. See also file system."
  },
  {
    "key": 261,
    "value": "file system",
    "description": "A logical structure that facilitates the storage of data on a digital storage medium such as a hard drive, CD/DVD-ROM, or flash memory device."
  },
  {
    "key": 262,
    "value": "File Transfer Protocol (FTP)",
    "description": "An early and still widely used TCP/IP application-layer protocol for batch transfer of files or entire directories from one system to another."
  },
  {
    "key": 263,
    "value": "File Transfer Protocol Secure (FTPS)",
    "description": "A TCP/IP application layer protocol that is an extension of the FTP protocol, whereby authentication and transport are encrypted using SSL or TLS. See also File Transfer Protocol (FTP), Secure File Transfer Protocol (SFTP), Secure Sockets Layer (SSL), Transport Layer Security (TLS)."
  },
  {
    "key": 264,
    "value": "firewall",
    "description": "A device that controls the flow of network messages between networks. Placed at the boundary between the Internet and an organization’s internal network, firewalls enforce security policy by prohibiting all inbound traffic except for the specific types of traffic that are permitted to a select few systems."
  },
  {
    "key": 265,
    "value": "first-party cookie",
    "description": "A cookie whose origin matches the domain of the web server. See also cookie, third-party cookie."
  },
  {
    "key": 266,
    "value": "foreign key",
    "description": "A field in a table in a relational database management system that references a unique primary key in another table. See also field, index, relational database management system (RDBMS), row, table."
  },
  {
    "key": 267,
    "value": "forensic audit",
    "description": "An audit performed in support of an anticipated legal proceeding, such as a breach."
  },
  {
    "key": 268,
    "value": "fortune cookie",
    "description": "A folded, sweet cookie with a message written on a paper slip tucked inside."
  },
  {
    "key": 269,
    "value": "forward lineage",
    "description": "The tracking records of a dataset from its origin, throughout its use. See also lineage."
  },
  {
    "key": 270,
    "value": "function creep",
    "description": "Unsanctioned uses of personal information beyond what is approved by management and consented to by data subjects."
  },
  {
    "key": 271,
    "value": "functional requirements",
    "description": "Statements describing the required characteristics that a system must have to support business needs. See also non-functional requirements."
  },
  {
    "key": 272,
    "value": "functional testing",
    "description": "The portion of software testing in which functional requirements are verified. See also interface testing, migration testing, quality assurance testing (QAT), system testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 273,
    "value": "gate process",
    "description": "Any business process that consists of one or more review/approval gates, which must be completed before the process can continue."
  },
  {
    "key": 274,
    "value": "gateway",
    "description": "A device that acts as a protocol converter or that performs some other type of transformation of messages."
  },
  {
    "key": 275,
    "value": "GDPR",
    "description": "See General Data Protection Regulation (GDPR)."
  },
  {
    "key": 276,
    "value": "general computing controls (GCC)",
    "description": "See IT general controls (ITGC)."
  },
  {
    "key": 277,
    "value": "General Data Protection Regulation (GDPR)",
    "description": "A European Union regulation enacted in 2016 (enforced in 2018) that defines the data privacy rights and remedies of European residents."
  },
  {
    "key": 278,
    "value": "generalization",
    "description": "A de-identification technique in which exact numerals are replaced with number ranges. See also anonymization, k-anonymization, masking, pseudonymization, tokenization."
  },
  {
    "key": 279,
    "value": "Generally Accepted Privacy Principles (GAPP)",
    "description": "A privacy framework superseded by the Privacy Management Framework (PMF). See also Privacy Management Framework (PMF)."
  },
  {
    "key": 280,
    "value": "governance",
    "description": "Management’s control over policy and processes."
  },
  {
    "key": 281,
    "value": "GPS tracker",
    "description": "A device used to covertly or overtly track the location of a vehicle or other large, mobile object."
  },
  {
    "key": 282,
    "value": "granular consent",
    "description": "The ability for a data subject to select which tracking technologies they agree with."
  },
  {
    "key": 283,
    "value": "grid computing",
    "description": "A large number of loosely coupled computers that are used to solve a common task."
  },
  {
    "key": 284,
    "value": "guest",
    "description": "A virtual machine running under a hypervisor."
  },
  {
    "key": 285,
    "value": "guideline",
    "description": "A document that provides suggestions for compliance with a policy or standard."
  },
  {
    "key": 286,
    "value": "hacker",
    "description": "Someone who interferes with or accesses another’s computer without authorization. Formerly, a hobbyist who strives to understand how complex mechanisms function."
  },
  {
    "key": 287,
    "value": "hardening",
    "description": "The technique of configuring a system or device so that only its essential services and features are active, with all others deactivated, as well as improvements to security configuration settings. This helps reduce a system’s attack surface to its essential components."
  },
  {
    "key": 288,
    "value": "hardware",
    "description": "The physical machinery of computing, storage, and networks."
  },
  {
    "key": 289,
    "value": "hardware security module (HSM)",
    "description": "A device used to store and protect encryption keys."
  },
  {
    "key": 290,
    "value": "hash function",
    "description": "A cryptographic operation on a block of data that returns a fixed-length string of characters, used to verify the integrity of a message. See also message digest."
  },
  {
    "key": 291,
    "value": "hashing",
    "description": "The use of a hash function on a block of information, resulting in a digest."
  },
  {
    "key": 292,
    "value": "Health Information Technology for Economic and Clinical Health (HITECH)",
    "description": "A 2009 U.S. regulation that extends the HIPAA Security Rule and Privacy Rule. See also Health Insurance Portability and Accountability Act (HIPAA)."
  },
  {
    "key": 293,
    "value": "Health Insurance Portability and Accountability Act (HIPAA)",
    "description": "A U.S. regulation protecting electronic protected health information (ePHI) that applies to healthcare delivery organizations, health insurance companies, and other healthcare industry organizations. See also Health Information Technology for Economic and Clinical Health (HITECH)."
  },
  {
    "key": 294,
    "value": "hierarchical database management system",
    "description": "A database management system employing a top-down hierarchy data model."
  },
  {
    "key": 295,
    "value": "hierarchical file system (HFS)",
    "description": "A file system formerly used on computers running macOS. See also file system."
  },
  {
    "key": 296,
    "value": "homomorphic encryption",
    "description": "An encryption and data processing technique in which encrypted data can be processed without decryption."
  },
  {
    "key": 297,
    "value": "hybrid cloud",
    "description": "A distributed computing environment consisting of cloud-based and on-premises systems."
  },
  {
    "key": 298,
    "value": "hybrid cryptography",
    "description": "A cryptosystem that employs two or more iterations or types of cryptography."
  },
  {
    "key": 299,
    "value": "Hypertext Transfer Protocol (HTTP)",
    "description": "A TCP/IP application-layer protocol used to transmit web page content from web servers to users using web browsers."
  },
  {
    "key": 300,
    "value": "Hypertext Transfer Protocol Secure (HTTPS)",
    "description": "A TCP/IP application-layer protocol similar to HTTP in its role in transporting data between web servers and browsers. HTTPS is not a separate protocol; it is an instance of HTTP encrypted with SSL or TLS. See also Hypertext Transfer Protocol (HTTP), Secure Sockets Layer (SSL), Transport Layer Security (TLS)."
  },
  {
    "key": 301,
    "value": "hypervisor",
    "description": "Virtualization software that facilitates the operation of one or more virtual machines."
  },
  {
    "key": 302,
    "value": "identification",
    "description": "The process of asserting one’s identity without providing proof of that identity. See also authentication."
  },
  {
    "key": 303,
    "value": "identity management",
    "description": "The activity of managing the identity of each employee, contractor, temporary worker, and, optionally, customer for use in a single environment or multiple environments."
  },
  {
    "key": 304,
    "value": "identity proofing",
    "description": "Procedures to confirm the identity of a subject."
  },
  {
    "key": 305,
    "value": "identity theft",
    "description": "The practice of using stolen personal information for monetary gain."
  },
  {
    "key": 306,
    "value": "image",
    "description": "A preconfigured operating system for rapid installation onto a laptop or desktop computer."
  },
  {
    "key": 307,
    "value": "impact",
    "description": "The actual or expected result when a risk occurs."
  },
  {
    "key": 308,
    "value": "implementation",
    "description": "A step in the systems development lifecycle at which new or updated software is placed into the production environment and started."
  },
  {
    "key": 309,
    "value": "impossible login",
    "description": "Any instance where a login event is considered impossible, such as a login a great distance away from another recent login for the same user."
  },
  {
    "key": 310,
    "value": "incident (privacy)",
    "description": "See privacy incident."
  },
  {
    "key": 311,
    "value": "incident (security)",
    "description": "See security incident."
  },
  {
    "key": 312,
    "value": "incident management",
    "description": "The business processes and resources concerning the organized response to incidents. See also incident response."
  },
  {
    "key": 313,
    "value": "incident response",
    "description": "The organized response to a privacy or security incident. See also privacy incident response, security incident response."
  },
  {
    "key": 314,
    "value": "incognito mode",
    "description": "See privacy mode."
  },
  {
    "key": 315,
    "value": "independence",
    "description": "The characteristics of an auditor and their relationship to a party being audited. An auditor should be independent of the auditee; this permits the auditor to be objective."
  },
  {
    "key": 316,
    "value": "index",
    "description": "An entity in a relational database management system that facilitates rapid searching for specific rows in a table based on one of the fields other than the primary key. See also field, primary key, relational database management system (RDBMS), row, table."
  },
  {
    "key": 317,
    "value": "indicator of compromise (IoC)",
    "description": "Evidence of an attempted or successful intrusion or attack."
  },
  {
    "key": 318,
    "value": "industrial control system (ICS)",
    "description": "Networks and systems used to monitor and control industrial processes such as manufacturing or utilities. See also connected devices, Internet of Things (IoT), Supervisory Control and Data Acquisition (SCADA)."
  },
  {
    "key": 319,
    "value": "information classification",
    "description": "See data classification."
  },
  {
    "key": 320,
    "value": "information security governance",
    "description": "A governance program for information security. See also governance."
  },
  {
    "key": 321,
    "value": "information security management",
    "description": "The aggregation of policies, processes, procedures, and activities to ensure that an organization’s security policy is effective."
  },
  {
    "key": 322,
    "value": "information security management system (ISMS)",
    "description": "The collection of activities for managing information security, as defined by ISO/IEC 27001."
  },
  {
    "key": 323,
    "value": "information security policy",
    "description": "A statement that defines how an organization will classify and protect its important assets."
  },
  {
    "key": 324,
    "value": "information systems audit",
    "description": "An audit of an IT department’s operations related to the storage and processing of personal information."
  },
  {
    "key": 325,
    "value": "infrastructure",
    "description": "The collection of networks, network services, devices, facilities, and system software that facilitates access to, communications with, and protection of business applications."
  },
  {
    "key": 326,
    "value": "infrastructure-as-a-service (IaaS)",
    "description": "A cloud computing model in which a service provider makes computing and other infrastructure components available to subscribers. See also cloud computing."
  },
  {
    "key": 327,
    "value": "infrastructure-as-code (IaC)",
    "description": "The management of IT infrastructure through machine-readable definition files. See also software-defined networking (SDN)."
  },
  {
    "key": 328,
    "value": "inherent risk",
    "description": "The risk that there are material weaknesses in existing business processes and no controls to protect them."
  },
  {
    "key": 329,
    "value": "initialization vector (IV)",
    "description": "A random number that is needed by some encryption algorithms to begin the encryption process."
  },
  {
    "key": 330,
    "value": "injection attack",
    "description": "Any attack on an information system in which an attacker is attempting to trick the target system into executing the attacker’s computer code, thereby compromising the target."
  },
  {
    "key": 331,
    "value": "input authorization",
    "description": "Controls that ensure that all data input into an information system is authorized by management."
  },
  {
    "key": 332,
    "value": "input controls",
    "description": "Administrative and technical controls that determine what data is permitted to be input into an information system. These controls exist to ensure the integrity of information in a system."
  },
  {
    "key": 333,
    "value": "input validation",
    "description": "Controls that ensure the type and value of information entered into a system are appropriate and reasonable."
  },
  {
    "key": 334,
    "value": "integrated audit",
    "description": "An audit that combines an operational audit and a financial audit. See also financial audit, operational audit."
  },
  {
    "key": 335,
    "value": "integrated development environment (IDE)",
    "description": "A class of desktop software development tools that includes source code editing, source code version control, compilation, and debugging in a single tool."
  },
  {
    "key": 336,
    "value": "intellectual property",
    "description": "A class of assets owned by an organization; includes an organization’s designs, architectures, software source code, processes, and procedures."
  },
  {
    "key": 337,
    "value": "interface testing",
    "description": "Testing to confirm that a system is communicating properly with other systems. See also functional testing, migration testing, quality assurance testing (QAT), system testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 338,
    "value": "Internet",
    "description": "The interconnection of the world’s TCP/IP networks."
  },
  {
    "key": 339,
    "value": "Internet hygiene",
    "description": "The safe use of computers and mobile devices while accessing the Internet."
  },
  {
    "key": 340,
    "value": "Internet Protocol Security (IPsec)",
    "description": "A suite of protocols used to secure IP-based communications by using authentication and encryption. See also Point-to-Point Tunneling Protocol (PPTP), Layer 2 Tunneling Protocol (L2TP)."
  },
  {
    "key": 341,
    "value": "Internet of Things (IoT)",
    "description": "The connection of physical objects other than human-interactive computers to networks and the Internet."
  },
  {
    "key": 342,
    "value": "intrusion detection system (IDS)",
    "description": "A hardware or software system that detects anomalies that might be signs of an intrusion."
  },
  {
    "key": 343,
    "value": "intrusion prevention system (IPS)",
    "description": "A hardware or software system that detects and blocks anomalies that might be indications of an intrusion."
  },
  {
    "key": 344,
    "value": "IP address",
    "description": "An address assigned to a station on a TCP/IP network."
  },
  {
    "key": 345,
    "value": "IPsec",
    "description": "See Internet Protocol Security (IPsec)."
  },
  {
    "key": 346,
    "value": "IS audit guidelines",
    "description": "Published documents that help the IS auditor apply ISACA audit standards."
  },
  {
    "key": 347,
    "value": "IS audit procedures",
    "description": "Published documents that provide sample procedures for performing various audit activities and for auditing various types of technologies and systems."
  },
  {
    "key": 348,
    "value": "IS audit standards",
    "description": "The minimum standards of performance related to security, audits, and the actions that result from audits. The standards are published by ISACA and updated periodically. ISACA audit standards are considered mandatory by IS auditors worldwide."
  },
  {
    "key": 349,
    "value": "ISACA",
    "description": "An international professional association focused on IT governance."
  },
  {
    "key": 350,
    "value": "ISAE 3402 (International Standard on Assurance Engagement)",
    "description": "An international standard for the external audit of a service provider. An ISAE 3402 audit is performed in accordance with rules established by the International Auditing and Assurance Standards Board (IAASB). See also Statements on Standards for Attestation Engagements No. 18 (SSAE 18)."
  },
  {
    "key": 351,
    "value": "ISO/IEC 27001",
    "description": "An ISO/IEC standard for IT security management."
  },
  {
    "key": 352,
    "value": "ISO/IEC 27002",
    "description": "An ISO/IEC standard for IT security controls."
  },
  {
    "key": 353,
    "value": "ISO/IEC 27005",
    "description": "An ISO/IEC standard for cybersecurity risk assessments and risk management."
  },
  {
    "key": 354,
    "value": "ISO/IEC 27035",
    "description": "An ISO/IEC standard for cybersecurity incident response."
  },
  {
    "key": 355,
    "value": "ISO/IEC 27701",
    "description": "An ISO/IEC standard for privacy information management."
  },
  {
    "key": 356,
    "value": "ISO/IEC 5181",
    "description": "An international standard for data security, privacy, and provenance. The standard is still in draft at the time of this publication."
  },
  {
    "key": 357,
    "value": "ISO/IEC 9660",
    "description": "An ISO/IEC standard file system format used on CD-ROM and DVD-ROM media."
  },
  {
    "key": 358,
    "value": "IT Assurance Framework",
    "description": "An end-to-end framework developed to guide organizations in developing and managing IT assurance and IT audits."
  },
  {
    "key": 359,
    "value": "IT general controls (ITGC)",
    "description": "A framework of controls established in an organization that applies across core business systems. Generally used in the context of Sarbanes-Oxley compliance."
  },
  {
    "key": 360,
    "value": "IT service desk",
    "description": "See service desk."
  },
  {
    "key": 361,
    "value": "IT service management (ITSM)",
    "description": "A set of business processes used to manage an IT organization."
  },
  {
    "key": 362,
    "value": "iterative development",
    "description": "A software development process that consists of one or more loops of planning, requirements, design, coding, and testing until development and implementation are considered complete."
  },
  {
    "key": 363,
    "value": "job description",
    "description": "A written description of an employee’s responsibilities within an organization. A job description usually includes a job title, responsibilities, experience requirements, and knowledge requirements."
  },
  {
    "key": 364,
    "value": "job title",
    "description": "A label assigned to each person in an organization."
  },
  {
    "key": 365,
    "value": "judgmental sampling",
    "description": "A sampling technique by which items are chosen based on the auditor’s judgment, usually based on risk or materiality. See also sampling."
  },
  {
    "key": 366,
    "value": "k-anonymization",
    "description": "An anonymization technique in which identifying fields in subject data records are altered through generalization. See also anonymization, de-identification, masking, pseudonymization, re-identification, tokenization."
  },
  {
    "key": 367,
    "value": "key",
    "description": "See encryption key."
  },
  {
    "key": 368,
    "value": "key compromise",
    "description": "Any unauthorized disclosure or damage to an encryption key. See also key management."
  },
  {
    "key": 369,
    "value": "key control indicator (KCI)",
    "description": "A measure of activities related to selected controls to determine their effectiveness. See also key goal indicator (KGI), key performance indicator (KPI), key risk indicator (KRI)."
  },
  {
    "key": 370,
    "value": "key custody",
    "description": "The policies, processes, and procedures for managing keys. See also key management."
  },
  {
    "key": 371,
    "value": "key disposal",
    "description": "The process of decommissioning encryption keys. See also key management."
  },
  {
    "key": 372,
    "value": "key encrypting key",
    "description": "An encryption key used to encrypt another encryption key."
  },
  {
    "key": 373,
    "value": "key exchange",
    "description": "A technique used by two parties to establish a symmetric encryption key when no secure channel is available."
  },
  {
    "key": 374,
    "value": "key fingerprint",
    "description": "A short sequence of characters used to authenticate a public key."
  },
  {
    "key": 375,
    "value": "key generation",
    "description": "The initial generation of an encryption key. See also key management."
  },
  {
    "key": 376,
    "value": "key goal indicator (KGI)",
    "description": "A measure of business activities related to the achievement of strategic goals and objectives. See also key control indicator (KCI), key performance indicator (KPI), key risk indicator (KRI)."
  },
  {
    "key": 377,
    "value": "key length",
    "description": "The size (measured in bits) of an encryption key. Longer encryption keys mean it takes more effort to successfully attack a cryptosystem."
  },
  {
    "key": 378,
    "value": "key logger",
    "description": "A hardware device or a type of malware that records a user’s keystrokes and, optionally, mouse movements and clicks, and sends them to the key logger’s owner."
  },
  {
    "key": 379,
    "value": "key management",
    "description": "The various processes and procedures used by an organization to generate, protect, use, and dispose of encryption keys over their lifetime."
  },
  {
    "key": 380,
    "value": "key pair",
    "description": "A mathematically linked private encryption key and public encryption key. See also asymmetric encryption."
  },
  {
    "key": 381,
    "value": "key performance indicator (KPI)",
    "description": "A measure of business processes’ performance and quality, used to reveal trends related to efficiency and effectiveness of key processes in the organization. See also key control indicator (KCI), key goal indicator (KGI), key risk indicator (KRI)."
  },
  {
    "key": 382,
    "value": "key protection",
    "description": "All means used to protect encryption keys from unauthorized disclosure and harm. See also key management."
  },
  {
    "key": 383,
    "value": "key risk indicator (KRI)",
    "description": "A measure of business risk, used to reveal trends related to the risk levels of various activities, processes, and systems in an organization. See also key control indicator (KCI), key goal indicator (KGI), key performance indicator (KPI)."
  },
  {
    "key": 384,
    "value": "key rotation",
    "description": "The process of issuing a new encryption key and re-encrypting data protected with the new key. See also key management."
  },
  {
    "key": 385,
    "value": "LAMP",
    "description": "A technology stack consisting of Linux, Apache, MySQL, and Perl/PHP/Python."
  },
  {
    "key": 386,
    "value": "Layer 2 Tunneling Protocol (L2TP)",
    "description": "A tunneling protocol that encapsulates Layer 2 network traffic to create a virtual private network (VPN) over IP networks. See also Internet Protocol Security (IPsec), Point-to-Point Tunneling Protocol (PPTP)."
  },
  {
    "key": 387,
    "value": "least privilege",
    "description": "The concept whereby an individual user should have the lowest privilege level possible that still enables them to perform the required tasks."
  },
  {
    "key": 388,
    "value": "legal agreement",
    "description": "A formal, written arrangement between two or more parties that creates enforceable rights and obligations under applicable law."
  },
  {
    "key": 389,
    "value": "legal basis",
    "description": "The lawful justification that supports a specific action, decision, or principle. In the context of privacy, organizations must identify the legal basis that supports their collection, use, or sharing of personal information."
  },
  {
    "key": 390,
    "value": "legitimate interest",
    "description": "A rationale expressed for the justification for processing personal information that presupposes benefits for the data subject and the processor."
  },
  {
    "key": 391,
    "value": "Lightweight Directory Access Protocol (LDAP)",
    "description": "A TCP/IP application layer protocol used as a directory service for people and computing resources."
  },
  {
    "key": 392,
    "value": "likelihood",
    "description": "The chances of a risk occurring."
  },
  {
    "key": 393,
    "value": "linkage attack",
    "description": "A data re-identification attack accomplished through matching data fields in two or more datasets."
  },
  {
    "key": 394,
    "value": "load balancer",
    "description": "A network device that distributes traffic to a set of resources, such as a server cluster."
  },
  {
    "key": 395,
    "value": "local area network (LAN)",
    "description": "An interconnection of computers within a limited area, such as a single building. See also network."
  },
  {
    "key": 396,
    "value": "log review",
    "description": "An examination of an event log to determine whether any security, privacy, or operational incident has occurred."
  },
  {
    "key": 397,
    "value": "log server",
    "description": "An information system that serves as a centralized collection point for event logs."
  },
  {
    "key": 398,
    "value": "LTE (Long Term Evolution)",
    "description": "A wireless telecommunications standard for use by mobile devices, considered an upgrade of older Global System for Mobile Communications (GSM) and CDMA2000 standards."
  },
  {
    "key": 399,
    "value": "machine learning",
    "description": "Computer algorithms that improve and self-correct through the acquisition of experience."
  },
  {
    "key": 400,
    "value": "main storage",
    "description": "A computer’s short-term storage of information, usually implemented with electronic components such as random access memory (RAM)."
  },
  {
    "key": 401,
    "value": "mainframe",
    "description": "A large central computer capable of performing complex tasks for several users simultaneously."
  },
  {
    "key": 402,
    "value": "maintenance",
    "description": "A step in the systems development lifecycle in which routine maintenance activities are performed."
  },
  {
    "key": 403,
    "value": "malware",
    "description": "The broad class of programs that are designed to inflict harm on computers, networks, or information. Types of malware include viruses, worms, Trojan horses, spyware, and rootkits."
  },
  {
    "key": 404,
    "value": "mandatory access control (MAC)",
    "description": "An access model used to control access to objects (files, directories, databases, systems, networks, and so on) by subjects (persons, programs, and so on). Access changes are performed by system administrators. See also discretionary access control (DAC)."
  },
  {
    "key": 405,
    "value": "marking",
    "description": "See document marking."
  },
  {
    "key": 406,
    "value": "masking",
    "description": "A technique of concealing the contents of data. See also anonymization, de-identification, k-anonymization, pseudonymization, re-identification, tokenization."
  },
  {
    "key": 407,
    "value": "maturity",
    "description": "The degree of formality and integrity of a business process."
  },
  {
    "key": 408,
    "value": "mean time to detect (MTTD)",
    "description": "The elapsed time from the onset of a privacy incident to the realization that an incident has occurred."
  },
  {
    "key": 409,
    "value": "mean time to resolve (MTTR)",
    "description": "See mean time to restore service (MTTRS)."
  },
  {
    "key": 410,
    "value": "mean time to respond (MTTR)",
    "description": "The elapsed time from the detection of a privacy incident to the start of the response."
  },
  {
    "key": 411,
    "value": "mean time to restore service (MTTRS)",
    "description": "The elapsed time from the detection of a privacy incident to its resolution."
  },
  {
    "key": 412,
    "value": "membership inference",
    "description": "An attack on an AI system in which an attacker attempts to determine whether an individual data subject’s data was a part of the AI system’s training data."
  },
  {
    "key": 413,
    "value": "message digest",
    "description": "The result of a cryptographic hash function."
  },
  {
    "key": 414,
    "value": "metadata",
    "description": "Structured data about data used by an organization, including the source, format, collection date, licensing, and any preprocessing."
  },
  {
    "key": 415,
    "value": "methodology standard",
    "description": "A standard that specifies the practices used by the IT organization."
  },
  {
    "key": 416,
    "value": "metrics",
    "description": "Ongoing and periodic measurements of system and process activities. See also key control indicator (KCI), key goal indicator (KGI), key performance indicator (KPI), key risk indicator (KRI)."
  },
  {
    "key": 417,
    "value": "microsegmentation",
    "description": "A segmentation technique in which individual hosts are isolated with network access controls, typically network or host firewalls."
  },
  {
    "key": 418,
    "value": "microservices",
    "description": "A software application architecture in which an application’s various functions are built as standalone modules with APIs to communicate with one another. See also monolithic architecture."
  },
  {
    "key": 419,
    "value": "Microsoft Active Directory (AD)",
    "description": "A directory service developed by Microsoft, derived from LDAP, and used for authentication and other uses."
  },
  {
    "key": 420,
    "value": "migration",
    "description": "The process of transferring data from one system to a replacement system."
  },
  {
    "key": 421,
    "value": "migration testing",
    "description": "Testing to ensure that data has been properly migrated from one system to another. See also functional testing, interface testing, quality assurance testing (QAT), system testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 422,
    "value": "minimization",
    "description": "The privacy concept in which only the minimum necessary amount of personal information should be collected and retained only as long as necessary."
  },
  {
    "key": 423,
    "value": "mobile application management (MAM)",
    "description": "A class of enterprise tools used to manage software applications on mobile devices such as smartphones and tablet computers."
  },
  {
    "key": 424,
    "value": "mobile backend-as-a-service (MBaaS)",
    "description": "A class of cloud-based services consisting of backend storage and APIs, in support of mobile applications. See also cloud computing."
  },
  {
    "key": 425,
    "value": "mobile device",
    "description": "A portable computer in the form of a smartphone, tablet computer, or wearable device."
  },
  {
    "key": 426,
    "value": "mobile device management (MDM)",
    "description": "A class of enterprise tools used to manage mobile devices such as smartphones and tablet computers."
  },
  {
    "key": 427,
    "value": "model inversion",
    "description": "An attack on an AI system in which an attacker queries the AI system and analyzes its outputs to reconstruct its private training data, which can determine whether any specific data subject’s data was used to train it."
  },
  {
    "key": 428,
    "value": "modem",
    "description": "A device used to convert digital data into analog form for transmission over a telephone line or radio."
  },
  {
    "key": 429,
    "value": "monetize",
    "description": "The practice of deriving value from a tangible or intangible asset, such as personal information."
  },
  {
    "key": 430,
    "value": "monitoring",
    "description": "The continuous or regular evaluation of a system or control to determine its operation or effectiveness."
  },
  {
    "key": 431,
    "value": "monolithic architecture",
    "description": "A software application architecture in which all functions of an application reside in a single, large application. See also microservices."
  },
  {
    "key": 432,
    "value": "multifactor authentication (MFA)",
    "description": "Any means used to authenticate a user that is stronger than the use of a user ID and password. Examples of multifactor authentication include a user ID and password, plus any one of the following: digital certificate, token, smart card, and biometric."
  },
  {
    "key": 433,
    "value": "near-field communications (NFC)",
    "description": "A standard for extremely short-distance radiofrequency data communications."
  },
  {
    "key": 434,
    "value": "NetFlow",
    "description": "A network diagnostic tool that collects all network metadata and can be used for network diagnostics or security purposes."
  },
  {
    "key": 435,
    "value": "network",
    "description": "An interconnection of computers for the purpose of exchanging information."
  },
  {
    "key": 436,
    "value": "network access control (NAC)",
    "description": "An approach for network authentication and access control for devices designed to attach to a LAN or wireless LAN."
  },
  {
    "key": 437,
    "value": "network architecture",
    "description": "The overall design of an organization’s network."
  },
  {
    "key": 438,
    "value": "network-attached storage (NAS)",
    "description": "A standalone storage system connected via a local area network."
  },
  {
    "key": 439,
    "value": "network protocol",
    "description": "An individual standard whereby information is carried over network media."
  },
  {
    "key": 440,
    "value": "network segmentation",
    "description": "The design process that results in the creation of network security zones, defined and controlled by firewalls or other stateful ACLs, that limit access between zones."
  },
  {
    "key": 441,
    "value": "Network Time Protocol (NTP)",
    "description": "A TCP/IP application-layer protocol used to synchronize the time-of-day clocks on systems with time-reference standards."
  },
  {
    "key": 442,
    "value": "NIST Cybersecurity Framework (NIST CSF)",
    "description": "A controls management framework developed by the U.S. National Institute of Standards and Technology."
  },
  {
    "key": 443,
    "value": "NIST Privacy Framework (NIST PF)",
    "description": "A U.S. industry standard for information privacy management."
  },
  {
    "key": 444,
    "value": "NIST SP 800-30",
    "description": "A NIST special publication regarding a standard methodology for conducting a risk assessment."
  },
  {
    "key": 445,
    "value": "NIST SP 800-39",
    "description": "A NIST special publication regarding a standard methodology for enterprise-wide multi-level risk management."
  },
  {
    "key": 446,
    "value": "NIST SP 800-53",
    "description": "A NIST special publication containing an industry standard control framework that is mandatory for all U.S. government agencies and contractors."
  },
  {
    "key": 447,
    "value": "NIST SP 800-53A",
    "description": "A NIST special publication containing audit procedures for controls found in NIST SP 800-53."
  },
  {
    "key": 448,
    "value": "NIST SP 800-122",
    "description": "A NIST special publication containing directives for protecting personal information, mandatory for all U.S. government agencies and contractors."
  },
  {
    "key": 449,
    "value": "non-functional requirements",
    "description": "Requirements associated with the performance, reliability, capacity, scalability, and other attributes of a system that are not associated with its specific functionality. See also functional requirements."
  },
  {
    "key": 450,
    "value": "nonrepudiation",
    "description": "The property of digital signatures and encryption that can make it difficult or impossible for a party to deny having sent a digitally signed message—unless they admit to having lost control of their private encryption key."
  },
  {
    "key": 451,
    "value": "NoSQL",
    "description": "An inclusive term referring to several non-relational database management system designs."
  },
  {
    "key": 452,
    "value": "notice of privacy practices (NOPP)",
    "description": "A statement published by an organization that describes the collection, protection, use, and disposal of personal information, as well as guidance on data subject requests for correction and removal."
  },
  {
    "key": 453,
    "value": "NT File System (NTFS)",
    "description": "A file system used by newer versions of the Microsoft Windows operating system. See also file system."
  },
  {
    "key": 454,
    "value": "object",
    "description": "A resource, such as a computer, application, database, file, or record. See also subject."
  },
  {
    "key": 455,
    "value": "object database",
    "description": "See object database management system (ODBMS)."
  },
  {
    "key": 456,
    "value": "object database management system (ODBMS)",
    "description": "A type of database management system in which information is represented as objects that are used in object-oriented programming languages."
  },
  {
    "key": 457,
    "value": "objectivity",
    "description": "The characteristic of a person that relates to their ability to develop an opinion that is not influenced by external pressures."
  },
  {
    "key": 458,
    "value": "one-time password",
    "description": "A password that can be used only once."
  },
  {
    "key": 459,
    "value": "Open Web Application Security Project (OWASP)",
    "description": "A nonprofit organization that helps software developers better understand the techniques needed for secure application development and deployment."
  },
  {
    "key": 460,
    "value": "operating system",
    "description": "A large, general-purpose program that is used to control computer hardware and facilitate the use of software applications."
  },
  {
    "key": 461,
    "value": "operational audit",
    "description": "An audit of IS controls, security controls, or business controls to determine control existence and effectiveness."
  },
  {
    "key": 462,
    "value": "Operationally Critical Threat, Asset, and Vulnerability Evaluation (OCTAVE)",
    "description": "A risk-analysis approach developed by Carnegie Mellon University for assessing privacy and security risks."
  },
  {
    "key": 463,
    "value": "orchestration",
    "description": "A scripted, automated response that is triggered when specific events occur."
  },
  {
    "key": 464,
    "value": "organization chart",
    "description": "A diagram that depicts the manager–subordinate relationships in an organization or in a part of an organization."
  },
  {
    "key": 465,
    "value": "Organisation for Economic Co-operation and Development (OECD) Privacy Principles",
    "description": "A foundational set of internationally recognized privacy guidelines."
  },
  {
    "key": 466,
    "value": "organizational inertia",
    "description": "An organization’s resistance to change."
  },
  {
    "key": 467,
    "value": "owner",
    "description": "A person or group responsible for the operation of a process, procedure, or asset."
  },
  {
    "key": 468,
    "value": "passphrase",
    "description": "A longer password that is constructed from a string of words."
  },
  {
    "key": 469,
    "value": "password",
    "description": "An identifier created by a system manager or a user; this secret combination of letters, numbers, and other symbols is known (or should be known) only to the user."
  },
  {
    "key": 470,
    "value": "password complexity",
    "description": "The characteristics required of user account passwords. For example, a password cannot contain dictionary words and must contain uppercase letters, lowercase letters, numbers, and symbols."
  },
  {
    "key": 471,
    "value": "password expiration",
    "description": "The maximum period before a password must be replaced."
  },
  {
    "key": 472,
    "value": "password length",
    "description": "The minimum and maximum number of characters permitted for a password that is associated with a computer account."
  },
  {
    "key": 473,
    "value": "password lockout",
    "description": "The automatic disabling of a user account after a set number of unsuccessful login attempts within a defined time."
  },
  {
    "key": 474,
    "value": "password reset",
    "description": "The process of changing a user account password and unlocking the user account so that the user’s use of the account can resume."
  },
  {
    "key": 475,
    "value": "password reuse",
    "description": "The act of reusing a prior password for a user account. Some information systems can prevent password reuse in the event of a password compromise, with or without the user’s knowledge."
  },
  {
    "key": 476,
    "value": "password vaulting",
    "description": "The process of storing a password in a secure location for later use."
  },
  {
    "key": 477,
    "value": "patch management",
    "description": "The process of applying patches (including security patches) to systems."
  },
  {
    "key": 478,
    "value": "Payment Card Industry Data Security Standard (PCI DSS)",
    "description": "A security standard whose objective is the protection of credit card numbers while in storage, while processed, and while transmitted. The standard was developed by the Payment Card Industry, a consortium of credit card companies, including VISA, MasterCard, American Express, Discover, and JCB."
  },
  {
    "key": 479,
    "value": "penetration test",
    "description": "A simulation of an attack on a system or network to identify the presence of exploitable vulnerabilities."
  },
  {
    "key": 480,
    "value": "peripheral device",
    "description": "An external device connected to a computer. Examples include additional storage, printers, monitors, and keyboards."
  },
  {
    "key": 481,
    "value": "persistent cookie",
    "description": "A cookie used to identify a user and store user preferences. See also cookie."
  },
  {
    "key": 482,
    "value": "Personal Information Protection and Electronic Documents Act (PIPEDA)",
    "description": "A Canadian data privacy law that went into effect in 2000, which seeks to ensure consumer data privacy in the context of e-commerce."
  },
  {
    "key": 483,
    "value": "Personal Information Protection Law (PIPL)",
    "description": "A Chinese law that governs how organizations collect, process, and transfer information."
  },
  {
    "key": 484,
    "value": "personally identifiable information (PII)",
    "description": "Any information relating to an identifiable natural person."
  },
  {
    "key": 485,
    "value": "phishing",
    "description": "A social engineering attack on unsuspecting individuals in which email messages resembling official communications entice victims to visit imposter websites that contain malware or request credentials for sensitive or valuable assets."
  },
  {
    "key": 486,
    "value": "plaintext",
    "description": "An original message, file, or stream of data that can be read by anyone who has access to it. See also ciphertext, encryption."
  },
  {
    "key": 487,
    "value": "platform-as-a-service (PaaS)",
    "description": "A cloud computing delivery model whereby the service provider supplies the platform on which an organization can build and run software. See also cloud computing."
  },
  {
    "key": 488,
    "value": "playbook",
    "description": "A detailed procedure, typically the instructions to be followed in response to an event or incident."
  },
  {
    "key": 489,
    "value": "Point-to-Point Tunneling Protocol (PPTP)",
    "description": "A deprecated protocol used for virtual private networks (VPNs). See also Internet Protocol Security (IPsec), Layer 2 Tunneling Protocol (L2TP)."
  },
  {
    "key": 490,
    "value": "policy",
    "description": "A statement that specifies what must be done (or not done) in an organization. A policy usually defines who is responsible for monitoring and enforcing it."
  },
  {
    "key": 491,
    "value": "population",
    "description": "A complete set of subjects, entities, transactions, or events that are the subject of an audit."
  },
  {
    "key": 492,
    "value": "position title",
    "description": "See job title."
  },
  {
    "key": 493,
    "value": "preventive action",
    "description": "An action that is initiated to prevent an undesired event or condition. See also corrective action."
  },
  {
    "key": 494,
    "value": "primary key",
    "description": "One of the fields in a table in a relational database management system whose values are unique for each record (row). See also field, relational database management system (RDBMS), row, table."
  },
  {
    "key": 495,
    "value": "privacy",
    "description": "The protection of personal information from unauthorized disclosure, use, and distribution."
  },
  {
    "key": 496,
    "value": "privacy awareness",
    "description": "A formal program used to educate employees, users, customers, or constituents on required, acceptable, and unacceptable privacy-related behaviors. See also security awareness."
  },
  {
    "key": 497,
    "value": "privacy engineering",
    "description": "The application of engineering principles to ensure that personal information is protected and used only as directed by policy and approved by management. See also engineering."
  },
  {
    "key": 498,
    "value": "privacy-enhancing technologies (PETs)",
    "description": "Any of several techniques that facilitate the processing and use of personal information while minimizing exposure and re-identification risk."
  },
  {
    "key": 499,
    "value": "privacy governance",
    "description": "Management’s control over an organization’s information privacy program."
  },
  {
    "key": 500,
    "value": "privacy impact assessment (PIA)",
    "description": "An analysis of how personally identifiable information is collected, used, shared, and maintained as part of planned changes to a business process or information system to identify any changes in privacy risk. See also data protection impact assessment (DPIA)."
  },
  {
    "key": 501,
    "value": "privacy incident",
    "description": "An event in which personal information has been misused, accessed by unauthorized persons, or affected by a security incident. See also security incident."
  },
  {
    "key": 502,
    "value": "Privacy Information Management System (PIMS)",
    "description": "The collection of activities for managing information privacy, as defined by ISO/IEC 27701."
  },
  {
    "key": 503,
    "value": "privacy labels",
    "description": "See consent tagging."
  },
  {
    "key": 504,
    "value": "Privacy Management Framework (PMF)",
    "description": "An operational privacy framework developed by the AICPA Privacy Task Force."
  },
  {
    "key": 505,
    "value": "privacy mode",
    "description": "A browser setting in which the tracking of website visits is not included in its website history."
  },
  {
    "key": 506,
    "value": "privacy office",
    "description": "A corporate oversight function that ensures that the organization complies with applicable privacy laws and other related requirements."
  },
  {
    "key": 507,
    "value": "privacy policy",
    "description": "A policy statement that defines how an organization will protect, manage, and handle private information."
  },
  {
    "key": 508,
    "value": "privacy requirements",
    "description": "Formal statements that describe required privacy safeguards that a system must support."
  },
  {
    "key": 509,
    "value": "privacy steering committee",
    "description": "A body of senior managers or executives that establishes priorities and provides oversight for activities and issues related to information privacy in the organization."
  },
  {
    "key": 510,
    "value": "private cloud",
    "description": "The use of infrastructure-as-a-service (IaaS) that is dedicated to a single customer and hosted by a service provider."
  },
  {
    "key": 511,
    "value": "private key cryptosystem",
    "description": "See symmetric key cryptosystem."
  },
  {
    "key": 512,
    "value": "privilege escalation",
    "description": "The act of obtaining higher access rights or permissions than are authorized."
  },
  {
    "key": 513,
    "value": "privileged access management (PAM)",
    "description": "Policies, processes, and tools to govern the use of privileged user accounts and service accounts."
  },
  {
    "key": 514,
    "value": "probability",
    "description": "See likelihood."
  },
  {
    "key": 515,
    "value": "problem management",
    "description": "As defined in IT service management, a situation characterized by several similar incidents. See also IT service management, incident management."
  },
  {
    "key": 516,
    "value": "procedure",
    "description": "A written sequence of instructions used to complete a task."
  },
  {
    "key": 517,
    "value": "process",
    "description": "A collection of one or more procedures used to perform a business function. See also procedure. A logical container in an operating system in which a program executes."
  },
  {
    "key": 518,
    "value": "process isolation",
    "description": "A basic feature of an operating system that prevents one process from accessing the resources used by another process."
  },
  {
    "key": 519,
    "value": "program",
    "description": "An organization of many large, complex activities; it can be thought of as a set of projects that work to fulfill one or more key business objectives."
  },
  {
    "key": 520,
    "value": "program charter",
    "description": "A formal definition of the objectives of a program, its main timelines, sources of funding, the names of its principal leaders and managers, and the business executive(s) who are sponsoring the program."
  },
  {
    "key": 521,
    "value": "program management",
    "description": "The management of a group of projects that exist to fulfill a business goal or objective."
  },
  {
    "key": 522,
    "value": "programming language",
    "description": "A vocabulary and set of rules used to construct a human-readable computer program."
  },
  {
    "key": 523,
    "value": "protected health information (PHI)",
    "description": "Patient-related healthcare information, as defined by the U.S. Health Insurance Portability and Accountability Act (HIPAA). See also electronic protected healthcare information (ePHI)."
  },
  {
    "key": 524,
    "value": "protocol standard",
    "description": "A standard that specifies the protocols used by the IT organization."
  },
  {
    "key": 525,
    "value": "provided by client (PBC) list",
    "description": "A list of evidence requested of an auditee at the onset of an audit."
  },
  {
    "key": 526,
    "value": "provisioning",
    "description": "The creation of a user account and the issuance of credentials to the user."
  },
  {
    "key": 527,
    "value": "pseudonymization",
    "description": "A de-identification procedure whereby a specific identifier is replaced by other values to make it less identifiable to the original data subject. See also anonymization, de-identification, k-anonymization, masking, re-identification, tokenization."
  },
  {
    "key": 528,
    "value": "public cloud",
    "description": "A commercial computing, storage, or processing service accessible over the Internet."
  },
  {
    "key": 529,
    "value": "public key cryptography",
    "description": "See asymmetric encryption."
  },
  {
    "key": 530,
    "value": "public key infrastructure (PKI)",
    "description": "A centralized function that is used to store and publish public keys and other information."
  },
  {
    "key": 531,
    "value": "purpose limitation",
    "description": "The privacy concept that requires organizations collecting personal information to use it only for disclosed purposes."
  },
  {
    "key": 532,
    "value": "purpose-based tagging",
    "description": "See consent tagging."
  },
  {
    "key": 533,
    "value": "qualitative risk analysis",
    "description": "A risk analysis methodology in which risks are classified on a nonquantitative scale, such as High, Medium, or Low, or on a simple numeric scale, such as 1 through 5. See also quantitative risk analysis, semi-quantitative risk analysis."
  },
  {
    "key": 534,
    "value": "quality assurance testing (QAT)",
    "description": "The portion of software testing in which system specifications and technologies are formally tested. See also functional testing, interface testing, migration testing, system testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 535,
    "value": "quantitative risk analysis",
    "description": "A risk analysis methodology in which risks are estimated as actual cost amounts. See also qualitative risk analysis, semi-quantitative risk analysis."
  },
  {
    "key": 536,
    "value": "RACI (Responsible-Accountable-Consulted-Informed)",
    "description": "The responsibility model used to track individual responsibilities in a business process or a project."
  },
  {
    "key": 537,
    "value": "radio frequency identification (RFID)",
    "description": "Technologies used to track the presence and/or movement of physical objects."
  },
  {
    "key": 538,
    "value": "random access memory (RAM)",
    "description": "A type of semiconductor memory usually used for a computer’s main storage."
  },
  {
    "key": 539,
    "value": "ransomware",
    "description": "Malware that performs a malicious action and requires payment from the victim to reverse it. Malicious actions include data erasure, data encryption, and system damage."
  },
  {
    "key": 540,
    "value": "records",
    "description": "Documents describing business events such as meeting minutes, contracts, financial transactions, decisions, purchase orders, logs, and reports."
  },
  {
    "key": 541,
    "value": "records of processing activities (ROPA)",
    "description": "A documented inventory of an organization’s processing of personal information."
  },
  {
    "key": 542,
    "value": "reduced sign-on (RSO)",
    "description": "The use of a centralized directory service (such as LDAP or Microsoft Active Directory) for authentication into systems and applications. Users need to log in to each system and application using a single set of login credentials. See also Lightweight Directory Access Protocol (LDAP), single sign-on."
  },
  {
    "key": 543,
    "value": "Redundant Array of Independent Disks (RAID)",
    "description": "A family of technologies used to improve the reliability, performance, or size of disk-based storage systems."
  },
  {
    "key": 544,
    "value": "referential integrity",
    "description": "The characteristic of relational database management systems that requires the DBMS to maintain parent-child relationships between records in different tables and prohibits activities such as deleting parent records and orphaning child records. See also primary key, relational database management system (RDBMS)."
  },
  {
    "key": 545,
    "value": "registration authority (RA)",
    "description": "An entity that works within or alongside a certificate authority (CA) to accept requests for new digital certificates."
  },
  {
    "key": 546,
    "value": "regulatory requirements",
    "description": "Formal statements, derived from laws and regulations, that describe the required characteristics a system must support."
  },
  {
    "key": 547,
    "value": "re-identification",
    "description": "Any technique that results in a record being identified to a data subject, despite attempts at de-identification. See also anonymization, de-identification, k-anonymization, masking, pseudonymization, tokenization."
  },
  {
    "key": 548,
    "value": "relational database management system (RDBMS)",
    "description": "A database management system that permits the design of a database consisting of one or more tables that can contain fields that refer to rows in other tables. This is currently the most popular type of database management system."
  },
  {
    "key": 549,
    "value": "remediation",
    "description": "The correction of a defect."
  },
  {
    "key": 550,
    "value": "remote access",
    "description": "A capability that permits a user to establish a network connection from a remote location so that the user can access internal network resources from a remote location."
  },
  {
    "key": 551,
    "value": "Remote Authentication Dial-in User Service (RADIUS)",
    "description": "An authentication, authorization, and accounting (AAA) protocol."
  },
  {
    "key": 552,
    "value": "reperformance",
    "description": "An audit technique in which an IS auditor repeats the actual tasks performed by auditees to confirm they were performed properly."
  },
  {
    "key": 553,
    "value": "replication",
    "description": "An activity in which data that is written to a storage system is also copied over a network to another storage system and written. The result is up-to-date data across two or more storage systems, each located in a different geographic region."
  },
  {
    "key": 554,
    "value": "request for information (RFI)",
    "description": "A formal solicitation to outside organizations for detailed information about specific types of products or services."
  },
  {
    "key": 555,
    "value": "request for proposal (RFP)",
    "description": "A formal solicitation to outside organizations for business proposals for specific types of products or services."
  },
  {
    "key": 556,
    "value": "request fulfillment workflow",
    "description": "The procedure for responding to a data subject request (DSR)."
  },
  {
    "key": 557,
    "value": "requirements",
    "description": "Formal statements that describe required (and desired) characteristics of a system that is to be changed, developed, or acquired."
  },
  {
    "key": 558,
    "value": "residual risk",
    "description": "The risk remaining after other risk treatment options have been applied."
  },
  {
    "key": 559,
    "value": "resilience",
    "description": "An essential characteristic of a system is that it will continue to operate despite component failures (network resilience) and be resistant to attack and abuse."
  },
  {
    "key": 560,
    "value": "Resilient File System (ReFS)",
    "description": "A file system used by Windows Server operating systems. See also file system, NT File System (NTFS)."
  },
  {
    "key": 561,
    "value": "responsibility",
    "description": "A stated expectation of activities and performance."
  },
  {
    "key": 562,
    "value": "retirement",
    "description": "The activities undertaken when an application or system reaches the end of its service life."
  },
  {
    "key": 563,
    "value": "return on investment (ROI)",
    "description": "The ratio of money gained or lost as compared to an original investment."
  },
  {
    "key": 564,
    "value": "right to audit",
    "description": "A clause in a contract that indicates that one party has the right to conduct an audit of the other party’s operations."
  },
  {
    "key": 565,
    "value": "risk",
    "description": "An undesired event that can happen that can damage an asset or disrupt operations."
  },
  {
    "key": 566,
    "value": "risk acceptance",
    "description": "The risk treatment option by which management chooses to accept the risk as-is."
  },
  {
    "key": 567,
    "value": "risk analysis",
    "description": "The process of identifying and studying risks in an organization."
  },
  {
    "key": 568,
    "value": "risk appetite",
    "description": "The level of risk that an organization is willing to accept while in pursuit of its mission, strategy, and objectives, and before action is needed to treat or manage the risk. See also risk capacity, risk tolerance."
  },
  {
    "key": 569,
    "value": "risk assessment",
    "description": "A process by which risks, in the form of threats and vulnerabilities, are identified for each asset."
  },
  {
    "key": 570,
    "value": "risk avoidance",
    "description": "The risk treatment option involving a cessation of the activity that introduces the identified risk."
  },
  {
    "key": 571,
    "value": "risk capacity",
    "description": "The maximum acceptable loss an organization can tolerate without its continued existence being called into question. See also risk appetite, risk tolerance."
  },
  {
    "key": 572,
    "value": "risk ledger",
    "description": "See risk register."
  },
  {
    "key": 573,
    "value": "risk management",
    "description": "The management activities used to identify, analyze, and treat risks."
  },
  {
    "key": 574,
    "value": "risk matrix",
    "description": "A visual depiction of probability, impact, and risk for a given asset."
  },
  {
    "key": 575,
    "value": "risk mitigation",
    "description": "The risk treatment option involving the implementation of a solution to reduce the impact of an identified risk."
  },
  {
    "key": 576,
    "value": "risk modification",
    "description": "See risk mitigation."
  },
  {
    "key": 577,
    "value": "risk reduction",
    "description": "See risk mitigation."
  },
  {
    "key": 578,
    "value": "risk register",
    "description": "The primary business record for a risk management program that contains risks that have been identified, scored, and treated."
  },
  {
    "key": 579,
    "value": "risk response",
    "description": "See risk treatment."
  },
  {
    "key": 580,
    "value": "risk retention",
    "description": "See risk acceptance."
  },
  {
    "key": 581,
    "value": "risk sharing",
    "description": "See risk transfer."
  },
  {
    "key": 582,
    "value": "risk tolerance",
    "description": "An organization’s level of acceptable variation from risk appetite."
  },
  {
    "key": 583,
    "value": "risk transfer",
    "description": "The risk treatment option that involves transferring risk to another party, such as an insurance company."
  },
  {
    "key": 584,
    "value": "risk treatment",
    "description": "The formal decision to manage an identified risk. The available choices are to mitigate, avoid, transfer, or accept the risk. See also risk acceptance, risk avoidance, risk management, risk mitigation, risk transfer."
  },
  {
    "key": 585,
    "value": "roadmap",
    "description": "The steps required to accomplish a strategic objective."
  },
  {
    "key": 586,
    "value": "role",
    "description": "A set of access rights in a system or application. A formally defined set of work tasks assigned to an individual."
  },
  {
    "key": 587,
    "value": "role-based access control (RBAC)",
    "description": "The practice of assigning users to roles, and granting access rights to roles instead of users, to streamline access management."
  },
  {
    "key": 588,
    "value": "rollback",
    "description": "A step in the systems development lifecycle where system changes need to be reversed, returning the system to its previous state."
  },
  {
    "key": 589,
    "value": "rollback planning",
    "description": "The development of procedures to execute a rollback."
  },
  {
    "key": 590,
    "value": "router",
    "description": "A device that is used to interconnect two or more networks."
  },
  {
    "key": 591,
    "value": "row",
    "description": "A unit of storage in a relational database management system that consists of a single record in a table. See also field, relational database management system (RDBMS), table."
  },
  {
    "key": 592,
    "value": "sample",
    "description": "A portion of the population of records selected for auditing. See also population."
  },
  {
    "key": 593,
    "value": "sampling",
    "description": "A technique used to select a portion of a population when it is not feasible to test an entire population."
  },
  {
    "key": 594,
    "value": "scanning",
    "description": "The practice of electronically querying target objects to obtain information about them. See also static DLP, vulnerability scanning."
  },
  {
    "key": 595,
    "value": "scope",
    "description": "The portion(s) of an organization, its assets, locations, systems, or personnel, to be included in an activity."
  },
  {
    "key": 596,
    "value": "secondary storage",
    "description": "A computer’s long-term storage of information, usually implemented with hard disk drives or solid-state drives (SSD)."
  },
  {
    "key": 597,
    "value": "secure development lifecycle (SDLC)",
    "description": "A structured approach to software development that integrates security practices and controls into every phase of the system lifecycle, from requirements through design, development, testing, deployment, and maintenance"
  },
  {
    "key": 598,
    "value": "Secure File Transfer Protocol (SFTP)",
    "description": "A TCP/IP application layer protocol that is an extension of FTP, whereby authentication and file transfer are encrypted using Secure Shell (SSH). Sometimes referred to as SSH File Transfer Protocol. See also File Transfer Protocol (FTP), File Transfer Protocol Secure (FTPS), Secure Shell (SSH)."
  },
  {
    "key": 599,
    "value": "Secure Multipurpose Internet Mail Extensions (S/MIME)",
    "description": "An email security protocol that provides sender and recipient authentication and encrypts message content and attachments."
  },
  {
    "key": 600,
    "value": "Secure Shell (SSH)",
    "description": "A TCP/IP application-layer protocol that provides a secure channel between two computers, encrypting all communications between them. SSH can also be used as a tunnel to encapsulate and thereby protect other protocols."
  },
  {
    "key": 601,
    "value": "Secure Sockets Layer (SSL)",
    "description": "An encryption protocol used to encrypt data in transit, including VPN and web pages requested with the HTTPS URL. Deprecated by Transport Layer Security (TLS). See also Hypertext Transfer Protocol Secure (HTTPS), Transport Layer Security (TLS), virtual private network (VPN)."
  },
  {
    "key": 602,
    "value": "security awareness",
    "description": "A formal program used to educate employees, users, customers, or constituents on required, acceptable, and unacceptable security-related behaviors."
  },
  {
    "key": 603,
    "value": "security governance",
    "description": "See information security governance."
  },
  {
    "key": 604,
    "value": "security incident",
    "description": "An event in which the confidentiality, integrity, or availability of information (or an information system) has been compromised."
  },
  {
    "key": 605,
    "value": "security incident response",
    "description": "The formal, planned response enacted when a security incident occurs. See also security incident."
  },
  {
    "key": 606,
    "value": "security information and event management system (SIEM)",
    "description": "An information system that collects event logs and generates alerts to inform personnel of events occurring that warrant attention and potential action."
  },
  {
    "key": 607,
    "value": "security orchestration, automation, and response (SOAR)",
    "description": "A system that automates routine and mundane tasks otherwise carried out by security analysts in response to security alerts."
  },
  {
    "key": 608,
    "value": "security policy",
    "description": "See information security policy."
  },
  {
    "key": 609,
    "value": "security requirements",
    "description": "Formal statements that describe the required security characteristics that a system must support."
  },
  {
    "key": 610,
    "value": "segmentation",
    "description": "See network segmentation."
  },
  {
    "key": 611,
    "value": "segregation of duties",
    "description": "The concept that ensures that individuals do not possess excessive privileges that could result in unauthorized activities, such as fraud or the manipulation or exposure of sensitive data."
  },
  {
    "key": 612,
    "value": "semi-quantitative risk analysis",
    "description": "A risk analysis methodology whereby risks are classified on a simple numeric scale, such as 1 through 5. See also qualitative risk analysis, quantitative risk analysis."
  },
  {
    "key": 613,
    "value": "Sensitive Personal Information (SPI)",
    "description": "A new personal information category defined by the California Privacy Rights Act (CPRA)."
  },
  {
    "key": 614,
    "value": "separation of duties",
    "description": "See segregation of duties."
  },
  {
    "key": 615,
    "value": "server",
    "description": "A centralized computer used to perform a specific task."
  },
  {
    "key": 616,
    "value": "serverless computing",
    "description": "An application operations cloud service model in which server operating systems are provided and managed by the cloud service provider."
  },
  {
    "key": 617,
    "value": "service account",
    "description": "A non-interactive user account used by applications and background processes."
  },
  {
    "key": 618,
    "value": "service desk",
    "description": "The IT function that handles incidents and service requests on behalf of customers by acting as a single point of contact. See also IT service management (ITSM)."
  },
  {
    "key": 619,
    "value": "service level agreement (SLA)",
    "description": "A formal commitment by an individual or group to provide services at stated levels of quantity and quality."
  },
  {
    "key": 620,
    "value": "service provider audit",
    "description": "An audit of a third-party organization that provides services to other organizations."
  },
  {
    "key": 621,
    "value": "service stack",
    "description": "See technology stack."
  },
  {
    "key": 622,
    "value": "session cookie",
    "description": "A cookie used by a web server that uniquely identifies a logged-in user from other logged-in users. See also cookie."
  },
  {
    "key": 623,
    "value": "shadow IT",
    "description": "The phenomenon in which organizational departments procure IT services directly, bypassing corporate IT."
  },
  {
    "key": 624,
    "value": "shared responsibility model",
    "description": "A logical model that depicts and describes operational responsibilities in a cloud services environment. The model indicates the responsibilities of the cloud service provider and the customer."
  },
  {
    "key": 625,
    "value": "SIM fraud",
    "description": "Fraud in which a perpetrator attempts to obtain a victim’s mobile device subscriber identity module (SIM) to take over the victim’s mobile phone number."
  },
  {
    "key": 626,
    "value": "Simple Mail Transfer Protocol (SMTP)",
    "description": "A TCP/IP application-layer protocol used to transport email messages."
  },
  {
    "key": 627,
    "value": "single loss expectancy (SLE)",
    "description": "In quantitative risk analysis, the financial loss incurred when a threat occurs once. SLE is defined as AV × EF. See also annualized loss expectancy (ALR), annualized rate of occurrence (ARO), asset value (AV), exposure factor (EF)."
  },
  {
    "key": 628,
    "value": "single sign-on (SSO)",
    "description": "An interconnected environment in which applications are logically connected to a centralized authentication server that is aware of the logged-in and/or logged-out status of each user. A user can log in once to the environment; each application and system is aware of the user’s login status and will not require the user to log in separately. See also reduced sign-on."
  },
  {
    "key": 629,
    "value": "site classification policy",
    "description": "See facility classification."
  },
  {
    "key": 630,
    "value": "smart card",
    "description": "A small, credit card–sized device that contains electronic memory and is accessed with a smart card reader and used in multifactor authentication."
  },
  {
    "key": 631,
    "value": "smartphone",
    "description": "A mobile phone equipped with an operating system and software applications."
  },
  {
    "key": 632,
    "value": "snapshot",
    "description": "A continuous auditing technique that involves the use of special audit modules embedded in online applications that sample specific transactions. The module copies key database records for later examination."
  },
  {
    "key": 633,
    "value": "SOC",
    "description": "See system and organization controls (SOC) audit."
  },
  {
    "key": 634,
    "value": "SOC 1",
    "description": "A system and organization controls audit of a financial services service provider using a bespoke set of controls. See also system and organization controls (SOC) audit."
  },
  {
    "key": 635,
    "value": "SOC 2",
    "description": "A system and organization controls audit of a service provider using a standard set of controls. See also system and organization controls (SOC) audit."
  },
  {
    "key": 636,
    "value": "social engineering",
    "description": "The act of using deception to trick an individual into revealing secrets or performing tasks."
  },
  {
    "key": 637,
    "value": "software-as-a-service (SaaS)",
    "description": "A software delivery model whereby an organization obtains a software application for use by its employees, and the software application is hosted by the software provider, as opposed to the customer organization. See also cloud computing."
  },
  {
    "key": 638,
    "value": "software composition analysis (SCA)",
    "description": "The practice of analyzing application source code to detect open-source software and determine whether it is up to date, free of vulnerabilities, and complies with any license requirements"
  },
  {
    "key": 639,
    "value": "software-defined network (SDN)",
    "description": "The class of technologies that facilitate the creation and management of virtual network devices. See also infrastructure-as-code (IaC)."
  },
  {
    "key": 640,
    "value": "software development lifecycle (SDLC)",
    "description": "See systems development lifecycle (SDLC)."
  },
  {
    "key": 641,
    "value": "software license",
    "description": "The process of maintaining accurate records regarding the permitted use of software programs."
  },
  {
    "key": 642,
    "value": "software maintenance",
    "description": "See maintenance."
  },
  {
    "key": 643,
    "value": "source code management",
    "description": "The techniques and tools used to manage application source code."
  },
  {
    "key": 644,
    "value": "source code repository",
    "description": "A system used to manage source code, including version control, protection, and check-out and check-in capabilities."
  },
  {
    "key": 645,
    "value": "spam",
    "description": "Unsolicited and unwanted email."
  },
  {
    "key": 646,
    "value": "spam filter",
    "description": "A central program or device that examines incoming email and removes all messages identified as spam."
  },
  {
    "key": 647,
    "value": "spiral model",
    "description": "A software development lifecycle process whereby the activities of requirements definition and software design go through several cycles until the project is complete. See also systems development lifecycle (SDLC)."
  },
  {
    "key": 648,
    "value": "split custody",
    "description": "The concept of splitting the knowledge of a specific object or task between two persons."
  },
  {
    "key": 649,
    "value": "split tunnel",
    "description": "A characteristic of a VPN connection in that network traffic destined to the organization’s internal network will traverse the VPN connection, whereas network traffic destined to the Internet will proceed directly to the Internet, bypassing the VPN connection."
  },
  {
    "key": 650,
    "value": "spyware",
    "description": "A type of malware in which software performs one or more surveillance-type actions on a computer, reporting back to the spyware owner."
  },
  {
    "key": 651,
    "value": "SSAE 18",
    "description": "See Statements on Standards for Attestation Engagements No. 18 (SSAE 18)."
  },
  {
    "key": 652,
    "value": "SSL decryption",
    "description": "See TLS inspection."
  },
  {
    "key": 653,
    "value": "standard",
    "description": "A statement that defines the technologies, protocols, suppliers, and methods used by an IT organization."
  },
  {
    "key": 654,
    "value": "standard contractual clauses (SCCs)",
    "description": "A legal agreement defining the business rules for the processing of personal information between legal jurisdictions."
  },
  {
    "key": 655,
    "value": "Statements on Standards for Attestation Engagements No. 18 (SSAE 18)",
    "description": "A standard for an external audit of a service provider. An SSAE 18 audit is performed in accordance with rules established by the American Institute of Certified Public Accountants (AICPA). See also ISAE 3402 (International Standard on Assurance Engagement)."
  },
  {
    "key": 656,
    "value": "static application security testing (SAST)",
    "description": "An automated scan of application source code to identify defects and security vulnerabilities."
  },
  {
    "key": 657,
    "value": "static DLP",
    "description": "The use of scanning tools to identify files containing PII or other sensitive information on file servers and other file stores. See also data loss prevention, dynamic DLP."
  },
  {
    "key": 658,
    "value": "statistical sampling",
    "description": "A sampling technique whereby items are chosen at random; each item has a statistically equal probability of being chosen. See also sampling."
  },
  {
    "key": 659,
    "value": "steering committee",
    "description": "A group of stakeholders that provides input to a corporate program."
  },
  {
    "key": 660,
    "value": "stop-or-go sampling",
    "description": "A sampling technique used to permit sampling to stop at the earliest possible time. This technique is used when the auditor believes that there is a low risk or a low rate of exceptions in the population. See also sampling."
  },
  {
    "key": 661,
    "value": "storage area network (SAN)",
    "description": "A standalone storage system that can be configured to contain several virtual volumes and can be connected to many servers through fiber-optic cables."
  },
  {
    "key": 662,
    "value": "strategic planning",
    "description": "Activities used to develop and refine an organization’s long-term plans and objectives."
  },
  {
    "key": 663,
    "value": "strategy",
    "description": "The plan to achieve an objective."
  },
  {
    "key": 664,
    "value": "stratified sampling",
    "description": "A sampling technique whereby a population is divided into classes or strata, based on the value of one of the attributes. Samples are then selected from each class. See also sampling."
  },
  {
    "key": 665,
    "value": "stream cipher",
    "description": "A type of encryption algorithm that operates on a continuous stream of data, such as a video or audio feed. See also block cipher."
  },
  {
    "key": 666,
    "value": "Strengths, Weaknesses, Opportunities, and Threats (SWOT)",
    "description": "A tool used in support of strategic planning to identify an organization’s strengths, weaknesses, opportunities, and threats."
  },
  {
    "key": 667,
    "value": "strong authentication",
    "description": "See multifactor authentication."
  },
  {
    "key": 668,
    "value": "structured data",
    "description": "Data that resides in database management systems and in other forms, as part of information systems and business applications. See also unstructured data."
  },
  {
    "key": 669,
    "value": "Structured Query Language (SQL)",
    "description": "A computer language used to query or update data in a relational database management system (RDBMS)."
  },
  {
    "key": 670,
    "value": "subject",
    "description": "In access controls, a person or a system. See also object. In information privacy, a natural person."
  },
  {
    "key": 671,
    "value": "subject data request",
    "description": "See data subject request (DSR)."
  },
  {
    "key": 672,
    "value": "super cookie",
    "description": "A cookie with an origin from a top-level domain (e.g.,.) used to track users across many domains. See also cookie."
  },
  {
    "key": 673,
    "value": "supervisory authority",
    "description": "An organization that has been delegated to enforce laws, perform investigations, and/or resolve disputes."
  },
  {
    "key": 674,
    "value": "supervisory control and data acquisition (SCADA)",
    "description": "Systems in which industrial processes are monitored and controlled through specialized devices and communications networks. See also connected devices, industrial control system (ICS), Internet of Things (IoT)."
  },
  {
    "key": 675,
    "value": "switch",
    "description": "A device used to connect computers and other devices to a network. Unlike a hub, which sends all network packets to all stations on the network, a switch sends packets only to the intended destination stations."
  },
  {
    "key": 676,
    "value": "symmetric encryption",
    "description": "A method for encryption and decryption in which both parties must possess a common encryption key."
  },
  {
    "key": 677,
    "value": "symmetric key cryptosystem",
    "description": "A cryptosystem that employs symmetric encryption keys. Also known as a private key cryptosystem."
  },
  {
    "key": 678,
    "value": "Synchronous Optical Networking (SONET)",
    "description": "A family of telecommunications standards for voice and data transport over a long-distance optical fiber."
  },
  {
    "key": 679,
    "value": "synthetic data",
    "description": "An artificial dataset whose statistical properties resemble those of an original dataset."
  },
  {
    "key": 680,
    "value": "system and organization controls (SOC) audit",
    "description": "An audit of a service provider’s controls, performed by a public accounting firm. See also ISAE 3402 (International Standard on Assurance Engagement), SOC 1, SOC 2, Statements on Standards for Attestation Engagements No. 18 (SSAE 18)."
  },
  {
    "key": 681,
    "value": "system classification",
    "description": "The process of assigning a sensitivity classification to an information system."
  },
  {
    "key": 682,
    "value": "system hardening",
    "description": "See hardening."
  },
  {
    "key": 683,
    "value": "system testing",
    "description": "The portion of software testing in which an entire system is tested. See also functional testing, interface testing, migration testing, quality assurance testing (QAT), system testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 684,
    "value": "systems development lifecycle (SDLC)",
    "description": "The lifecycle process used to develop or acquire and maintain information systems. Also known as the software development lifecycle."
  },
  {
    "key": 685,
    "value": "T-1",
    "description": "A common carrier standard protocol for transporting voice and data. T-1 can support up to 24 separate voice channels of 64 kbit/sec each and is used primarily in North America."
  },
  {
    "key": 686,
    "value": "T-3",
    "description": "A common carrier standard protocol for transporting voice and data. T-3 can support up to 672 separate voice channels of 64 kbit/sec each and is used primarily in North America."
  },
  {
    "key": 687,
    "value": "T-carrier",
    "description": "A class of multiplexed carrier network technologies developed to transport voice and data communications over long distances using copper cabling. See also E-carrier."
  },
  {
    "key": 688,
    "value": "table",
    "description": "A unit of storage in a relational database management system that can be thought of as a list of records. See also field, relational database management system (RDBMS), row."
  },
  {
    "key": 689,
    "value": "tablet computer",
    "description": "A mobile device with a touchscreen interface. See also mobile device."
  },
  {
    "key": 690,
    "value": "tabletop",
    "description": "An exercise, usually of privacy incident response, security incident response, and business continuity plans, that consists of a scripted simulation of an actual incident or event."
  },
  {
    "key": 691,
    "value": "TCP/IP network model",
    "description": "The four-layer network model that incorporates message encapsulation. The TCP/IP suite of protocols is built on the TCP/IP network model."
  },
  {
    "key": 692,
    "value": "technical requirements",
    "description": "Formal statements that describe the required technical characteristics that a system must support."
  },
  {
    "key": 693,
    "value": "technology stack",
    "description": "The layers of technology supporting a software application, usually including the operating system, database management system, web server, and programming language(s)."
  },
  {
    "key": 694,
    "value": "technology standard",
    "description": "A standard that specifies the software and hardware technologies that the IT organization uses."
  },
  {
    "key": 695,
    "value": "Telnet",
    "description": "A deprecated command-line interface protocol used to manage systems and devices. See also secure shell (SSH)."
  },
  {
    "key": 696,
    "value": "termination",
    "description": "The process of discontinuing the employment of an employee or contractor."
  },
  {
    "key": 697,
    "value": "test plan",
    "description": "The list of tests that are to be carried out during a unit test or system test. See also system testing, unit testing."
  },
  {
    "key": 698,
    "value": "third-party cookie",
    "description": "A cookie whose domain is different from the web server that creates the cookie. Often used for advertising tracking. See also cookie, first-party cookie."
  },
  {
    "key": 699,
    "value": "third-party risk management (TPRM)",
    "description": "A business process used to assess and treat risks related to third-party service providers."
  },
  {
    "key": 700,
    "value": "threat",
    "description": "An event that, if realized, would bring harm to an asset."
  },
  {
    "key": 701,
    "value": "threat actor",
    "description": "A human who has the ability to carry out a threat."
  },
  {
    "key": 702,
    "value": "threat agent",
    "description": "A human or non-human that has the ability to carry out a threat."
  },
  {
    "key": 703,
    "value": "threat hunting",
    "description": "The proactive search for intrusions, intruders, and indicators of compromise."
  },
  {
    "key": 704,
    "value": "threat intelligence",
    "description": "A humanor machine-readable feed of threat-related information that can help organizations better protect themselves from emerging threats."
  },
  {
    "key": 705,
    "value": "threat intelligence platform (TIP)",
    "description": "A system that receives threat intelligence data for use by security analysts, and is often integrated with a security information and event management (SIEM) system."
  },
  {
    "key": 706,
    "value": "three lines of defense",
    "description": "A governance framework that separates operations, privacy/compliance/ risk management, and internal audit."
  },
  {
    "key": 707,
    "value": "time synchronization",
    "description": "A network-based service that synchronizes the time clocks on computers to a standard time source."
  },
  {
    "key": 708,
    "value": "TLS",
    "description": "See Transport Layer Security (TLS)"
  },
  {
    "key": 709,
    "value": "TLS inspection",
    "description": "The practice of decrypting encrypted network traffic to examine its contents as part of an overall data loss prevention program designed to prevent security and privacy breaches."
  },
  {
    "key": 710,
    "value": "token",
    "description": "A small electronic device or smartphone app used in two-factor authentication. A token can display a number that the user types into a login field, or it can be plugged into a workstation to complete authentication. See also multifactor authentication."
  },
  {
    "key": 711,
    "value": "tokenization",
    "description": "A de-identification technique in which sensitive information is replaced by a token, which is often a pointer to a secure token vault where the original information can be found. See also anonymization, de-identification, k-anonymization, masking, pseudonymization, re-identification."
  },
  {
    "key": 712,
    "value": "transfer",
    "description": "The process of changing an employee’s job title, department, and/or responsibilities within an organization."
  },
  {
    "key": 713,
    "value": "transparency",
    "description": "The extent of an organization’s disclosure on the collection and use of personal information."
  },
  {
    "key": 714,
    "value": "Transport Layer Security (TLS)",
    "description": "An encryption protocol used to encrypt web pages requested with the HTTPS URL. Replacement for Secure Sockets Layer (SSL). See also Hypertext Transfer Protocol Secure (HTTPS), Secure Sockets Layer (SSL)."
  },
  {
    "key": 715,
    "value": "trusted execution environment",
    "description": "An environment in which sensitive and personal information is isolated and processed separately, so that other system components cannot access it."
  },
  {
    "key": 716,
    "value": "tunneling",
    "description": "The practice of encapsulating messages within another protocol. See also encapsulation."
  },
  {
    "key": 717,
    "value": "twisted-pair cable",
    "description": "A type of network cabling that consists of a thick cable containing four pairs of insulated copper conductors, all surrounded by a protective jacket."
  },
  {
    "key": 718,
    "value": "two-factor authentication",
    "description": "See multifactor authentication."
  },
  {
    "key": 719,
    "value": "unit testing",
    "description": "The portion of software testing in which individual modules are tested. See also functional testing, interface testing, quality assurance testing (QAT), system testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 720,
    "value": "Universal Disk Format (UDF)",
    "description": "An optical media file system considered a replacement for ISO/IEC 9660. See also file system, ISO/IEC 9660."
  },
  {
    "key": 721,
    "value": "universal serial bus (USB)",
    "description": "An external bus technology used to connect a computer to a peripheral such as a mouse, keyboard, storage device, printer, scanner, camera, and network adaptor. However, the USB specification indeed contains full networking capabilities, facilitated with a USB hub."
  },
  {
    "key": 722,
    "value": "unstructured data",
    "description": "Data that resides on end-user workstations and network file shares, usually as a result of the creation of reports and extracts. See also structured data."
  },
  {
    "key": 723,
    "value": "user acceptance testing (UAT)",
    "description": "The portion of software testing in which end users test software programs for correct functional operation and usability. See also functional testing, interface testing, migration testing, quality assurance testing (QAT), system testing, unit testing."
  },
  {
    "key": 724,
    "value": "user behavior analytics (UBA)",
    "description": "Tools and techniques that learn end-user behavior and generate alerts when it exceeds norms."
  },
  {
    "key": 725,
    "value": "user ID",
    "description": "An identifier that is created by a system manager and issued to a user for identification or authentication."
  },
  {
    "key": 726,
    "value": "V-model",
    "description": "A graphical representation of the systems development life cycle (SDLC)."
  },
  {
    "key": 727,
    "value": "variable sampling",
    "description": "A sampling technique used to study the characteristics of a population to determine the numeric total of a specific attribute from the entire population. See also sampling."
  },
  {
    "key": 728,
    "value": "vendor standard",
    "description": "A standard that specifies which suppliers and vendors are used for various types of products and services."
  },
  {
    "key": 729,
    "value": "version control",
    "description": "The techniques and tools used to manage different versions of source code files."
  },
  {
    "key": 730,
    "value": "vibe coding",
    "description": "An application development technique in which a software developer directs an AI LLM system to generate source code based on one or more prompts."
  },
  {
    "key": 731,
    "value": "view",
    "description": "A virtual table in a relational database management system (RDBMS) created by a stored query."
  },
  {
    "key": 732,
    "value": "virtual CISO (vCISO)",
    "description": "A chief information security officer (CISO) role filled by a part-time contractor resource."
  },
  {
    "key": 733,
    "value": "virtual desktop infrastructure (VDI)",
    "description": "A technology in which user workstations use operating systems stored and run on central servers."
  },
  {
    "key": 734,
    "value": "virtual machine",
    "description": "A software implementation of a computer, usually an operating system or other program running within a hypervisor. See also guest, hypervisor."
  },
  {
    "key": 735,
    "value": "virtual private cloud",
    "description": "A portion of a public cloud environment that is logically separated between customers."
  },
  {
    "key": 736,
    "value": "virtual private network (VPN)",
    "description": "Any network encapsulation protocol that utilizes authentication and encryption, used primarily for protecting remote access traffic and for protecting traffic between two networks. See also encapsulation, tunneling."
  },
  {
    "key": 737,
    "value": "virtual server",
    "description": "An active instantiation of a server operating system on a system designed to house two or more such virtual servers. Each virtual server is logically partitioned from every other so that each runs as though it were on its own physically separate machine."
  },
  {
    "key": 738,
    "value": "virtualization",
    "description": "The set of technologies that enables two or more running operating systems to reside and execute on a single physical system."
  },
  {
    "key": 739,
    "value": "virtualization sprawl",
    "description": "The uncontrolled or unmanaged creation of virtual machines and other virtual assets."
  },
  {
    "key": 740,
    "value": "virus",
    "description": "A type of malware in which fragments of code attach themselves to executable programs and are activated when the program they are attached to is run."
  },
  {
    "key": 741,
    "value": "Voice over IP (VoIP)",
    "description": "Several technologies that enable telephony transported over IP networks."
  },
  {
    "key": 742,
    "value": "volume",
    "description": "A logical allocation of storage in a storage system."
  },
  {
    "key": 743,
    "value": "VPN client",
    "description": "A software program used to establish a virtual private network connection. See also virtual private network (VPN)."
  },
  {
    "key": 744,
    "value": "vulnerability",
    "description": "A weakness present in a system that increases the probability of one or more threats occurring."
  },
  {
    "key": 745,
    "value": "vulnerability management",
    "description": "A formal business process used to identify and mitigate vulnerabilities in an IT environment."
  },
  {
    "key": 746,
    "value": "vulnerability scanning",
    "description": "The use of a tool that automatically identifies exploitable vulnerabilities on systems connected to a network."
  },
  {
    "key": 747,
    "value": "walkthrough",
    "description": "An audit technique in which a control owner describes procedures and provides evidence to auditors."
  },
  {
    "key": 748,
    "value": "waterfall model",
    "description": "A software development lifecycle process in which activities are sequential and executed once in a software project. See also systems development lifecycle (SDLC)."
  },
  {
    "key": 749,
    "value": "watering hole attack",
    "description": "An attack on an organization consists of compromising a website that personnel in the organization are known to frequent. This compromise then injects malware into visitors’ web browsers."
  },
  {
    "key": 750,
    "value": "watermarking",
    "description": "The practice of affixing human-readable identifiers on datasets and documents to inform viewers of their data classification."
  },
  {
    "key": 751,
    "value": "web-based application",
    "description": "An application design in which the database and all business logic are stored on central servers, and user workstations use only web browsers to access the application."
  },
  {
    "key": 752,
    "value": "web-based application development",
    "description": "A software development effort in which the application’s user interface is based on the HTTP (Hypertext Transfer Protocol) and HTML (Hypertext Markup Language) standards."
  },
  {
    "key": 753,
    "value": "web beacon",
    "description": "Use of a tiny or invisible image on a web page or email message for the purposes of tracking individual views of the image, along with other properties such as the IP address of the device viewing the web page or image."
  },
  {
    "key": 754,
    "value": "web content filter",
    "description": "A central program or device that monitors and, optionally, filters web communications. A web content filter is often used to control the sites (or categories of sites) that users are permitted to access from the workplace. Some web content filters can also protect an organization from malware."
  },
  {
    "key": 755,
    "value": "web server",
    "description": "A server that runs specialized software that makes static and dynamic HTML pages available to users."
  },
  {
    "key": 756,
    "value": "web services",
    "description": "A means for system-to-system communications using HTTP. See also application programming interface (API)."
  },
  {
    "key": 757,
    "value": "Web Services Description Language (WSDL)",
    "description": "An XML-based language used to describe web services. See also web services."
  },
  {
    "key": 758,
    "value": "web tracking",
    "description": "The use of any of several technologies and techniques for tracking the use of web page views and website viewing."
  },
  {
    "key": 759,
    "value": "Wi-Fi",
    "description": "The common name for a wireless LAN protocol."
  },
  {
    "key": 760,
    "value": "WISA",
    "description": "A technology stack consisting of Windows, IIS, SQL, and ASP.Net."
  },
  {
    "key": 761,
    "value": "Works Council",
    "description": "A body, similar to a labor union, that represents the rights of workers in an organization, and with whom an organization is required to negotiate on matters of the collection and use of workers’ personal information."
  },
  {
    "key": 762,
    "value": "World Wide Web Consortium (W3C) PROV",
    "description": "A set of recommended standards for the structure of data provenance information."
  },
  {
    "key": 763,
    "value": "zero-day",
    "description": "A vulnerability not yet disclosed to the public."
  },
  {
    "key": 764,
    "value": "zero-trust (ZT)",
    "description": "An architecture model in which a portion of an environment is considered to be untrusted."
  },
  {
    "key": 765,
    "value": "zombie cookie",
    "description": "A cookie placed on a user’s computer with safeguards to prevent deletion by the user. See also cookie."
  }
];
